<template>
  <ValidationObserver ref="newQuotationForm" v-slot="{ invalid }">
    <div :class="`${isLanding ? 'form-landing' : 'p-2'}`">
      <vx-card :class="!showPanel ? 'painel-no-border' : 'painel-border'">
        <div
          class="text-center mb-5"
          v-if="
            hideLogo != true && logo != '' && isInterno === false && !isLanding
          "
        >
          <img
            :src="logo"
            width="70%"
            style="display: inline; max-width: 250px"
            data-testId="logo-image"
          />
        </div>

        <vs-row vs-type="flex" class="no-padding-cols">
          <vs-col
            v-if="isEdition && quotation"
            class="flex items-center"
            style="flex: 1"
          >
            <h2 data-testId="quotation-id">
              Apólice nº
              {{
                formatEmitterNumber(
                  quotation.policyNumber,
                  POLICY_TYPES.AUTO,
                  'POLICY',
                )
              }}
            </h2>
          </vs-col>
          <vs-col
            class="flex w-auto justify-end items-center col-buttons col-buttons gap-1"
            v-if="
              step === 1 &&
              quotation &&
              quotation.endorsement &&
              quotation.quotation_pdf
            "
          >
            <vs-button
              @click="
                openPdf(
                  isAlreadyTransmitted
                    ? quotation.proposal_pdf
                    : quotation.quotation_pdf,
                )
              "
              color="success"
              type="gradient"
              icon-pack="feather"
              icon="icon-file-text"
              class="rounded-full"
              v-tooltip="
                `${isAlreadyTransmitted ? 'Proposta' : 'Cotação'} de Endosso`
              "
              data-testId="open-pdf-button"
            />
            <vs-button
              v-if="
                $can(
                  PERMISSIONS_ACTIONS.SHOW_ALTERATIONS_HISTORY,
                  PERMISSIONS_NAMES.QUOTATIONS,
                ) &&
                quotation &&
                quotation.endorsement
              "
              @click="historyAlterationsActive = true"
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-list"
              class="rounded-full"
              v-tooltip="'Histórico de Alterações'"
              data-testId="open-logs-button"
            />

            <vs-button
              v-if="quotation && quotation.endorsement"
              @click="historyMessagingActive = true"
              icon-pack="feather"
              icon="icon-mail"
              class="rounded-full purple-gradient-btn"
              v-tooltip="'Histórico de Mensageria'"
              data-testId="open-messaging-history-button"
            />
          </vs-col>
        </vs-row>
        <p v-if="quotation && quotation.cnsegCi">
          <span class="font-bold">CI:</span>
          {{ quotation.cnsegCi }}
        </p>
        <p v-if="policyStartCoverageDate">
          <span class="font-bold">Início da vigência:</span>
          {{ formatDateBr(policyStartCoverageDate) }}
        </p>
        <p v-if="quotation && quotation.end_of_validity">
          <span class="font-bold">Fim da vigência:</span>
          {{ formatDateBr(quotation.end_of_validity) }}
        </p>
        <p v-if="quotation && quotation.broker">
          <span class="font-bold">Corretora:</span>
          {{ quotation.broker.name }}
        </p>
        <p v-if="quotation && quotation.consultancy">
          <span class="font-bold">Assessoria:</span>
          {{ quotation.consultancy.name }}
        </p>

        <div v-if="step === 0">
          <!--Sessao endosso-->
          <div class="form-part-title mt-6 mb-6">
            <span>Endosso</span>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col sm:w-4/12 w-full">
              <label for="Metodo Endosso" class="vs-select--label">
                Operações de Endosso
              </label>
              <ValidationProvider
                name="Operação de endosso"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="operationTypes"
                  id="Operação de Endosso"
                  v-model="fieldsWithValidation.endorsement.method"
                  placeholder="Selecione a operação de endosso"
                  label="operationType"
                  data-testId="operation-type"
                  :disabled="blockSelectOperation || !hasWritePermission"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="operation-type-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div class="vx-col sm:w-3/12">
              <label for="Início da Vigência" class="vs-select--label">
                Início da Vigência
              </label>
              <ValidationProvider
                name="Início Vigência Endosso"
                rules="required"
              >
                <flat-pickr
                  ref="startValidityPicker"
                  class="input-data-ativacao"
                  id="Início Vigência Endosso"
                  v-model="fieldsWithValidation.endorsement.startDate"
                  :config="endorsementStartDateConfig"
                  placeholder="DD/MM/AAAA"
                  :disabled="
                    isQuotationBlocked() ||
                    !hasWritePermission ||
                    !fieldsWithValidation.endorsement.method
                  "
                  data-testId="start-of-validity"
                />
              </ValidationProvider>
              <span
                v-show="requiredStartVigencyDate.invalid"
                class="text-danger"
                data-testId="start-of-validity-error"
              >
                {{ requiredStartVigencyDate.message }}
              </span>
            </div>
          </div>

          <div>
            <vs-alert
              active="true"
              class="vehicle-alert text-light mt-3 p-3 mb-3"
            >
              <p>
                Caso o tipo de endosso desejado não esteja na lista acima,
                <a
                  :href="endorsementFormUrl"
                  target="_blank"
                  class="alert-link"
                >
                  <strong>clique aqui</strong> </a
                >.
              </p>
            </vs-alert>
          </div>
          <!--Fim Sessao endosso-->

          <!--Sessao Bonus-->
          <div class="form-part-title mt-6 mb-6">
            <span>Renovação e Bônus</span>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label for="Bonus" class="vs-select--label">
                É uma renovação?
              </label>
              <ValidationProvider
                name="É uma renovação?"
                :rules="
                  getValidationRules(
                    'renewal-selection',
                    'required',
                    originalQuotation.addition_information
                      .insurance_company_code,
                  )
                "
                v-slot="{ errors }"
              >
                <v-select
                  :options="insuranceCompanies"
                  id="É uma renovação?"
                  v-model="fieldsWithValidation.insuranceCompanyCode"
                  :reduce="(item) => item.id"
                  :danger="!!errors.length"
                  :filter="filterOptions"
                  data-testId="renewal-selection"
                  :disabled="!isFieldEditable('renewal-selection')"
                >
                  <template #selected-option="option">
                    {{ getSelectedCongenerLabel(option) }}
                  </template></v-select
                >
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="renewal-selection-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div v-if="isRenovationByCNSeg" class="vx-col sm:w-1/4 w-full mb-2">
              <label for="Bonus" class="vs-select--label">Nível de Bônus</label>
              <ValidationProvider
                name="Nível de Bônus"
                :rules="
                  getValidationRules(
                    'bonus-level',
                    'required',
                    originalQuotation.addition_information.bonus,
                  )
                "
                v-slot="{ errors }"
              >
                <v-select
                  :options="bonusesLevel"
                  id="Nível de Bônus"
                  v-model="fieldsWithValidation.bonus"
                  :reduce="(item) => item.id"
                  :danger="!!errors.length"
                  data-testId="bonus-level"
                  :disabled="!isFieldEditable('bonus-level')"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="bonus-level-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
          <!--Fim Sessao Bonus-->

          <!--Sessao Dados Segurado-->
          <div class="form-part-title mt-6 mb-6">
            <span>Dados do Segurado</span>
          </div>

          <div class="vx-row mb-4 w-full">
            <div class="vx-col w-full sm:w-3/12">
              <ValidationProvider
                name="CPF-CNPJ"
                :rules="
                  getValidationRules(
                    'insured-cpf-cnpj',
                    'required|cpf_cnpj_min|cpf_cnpj',
                    originalQuotation.prospect.tax_id,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="fieldsWithValidation.cpfcnpj"
                  class="w-full"
                  label="CPF-CNPJ"
                  id="cpfCnpjInput"
                  v-mask="[DOCUMENT_MASK.CPF_WITH_CNPJ, DOCUMENT_MASK.CNPJ]"
                  @input="fieldsWithValidation.cpfcnpj = $event.toUpperCase()"
                  :danger="!!errors.length"
                  data-testId="insured-cpf-cnpj"
                  :disabled="
                    !isInsuredMainDriverFieldEditable(
                      'insured-cpf-cnpj',
                      'driver-cpf-cnpj',
                    )
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-cpf-cnpj-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div v-if="!isPerson" class="vx-col w-full sm:w-6/12">
              <ValidationProvider
                name="Nome"
                :rules="
                  getValidationRules(
                    'insured-business-name',
                    'required|nome',
                    originalQuotation.prospect.name,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  :label="'Razão Social'"
                  v-model="fieldsWithValidation.name"
                  id="Nome"
                  :danger="!!errors.length"
                  data-testId="insured-business-name"
                  :disabled="!isFieldEditable('insured-business-name')"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-business-name-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div
              v-if="!isPerson && fieldsWithValidation.ie"
              class="vx-col w-full sm:w-3/12"
            >
              <ValidationProvider
                name="Inscrição Estadual"
                :rules="
                  getValidationRules(
                    'state-registration',
                    'required|max:14',
                    originalQuotation.prospect.stateRegistrationNumber,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  label="Inscrição Estadual"
                  v-model="fieldsWithValidation.ie"
                  v-mask="'##############'"
                  id="Inscrição Estadual"
                  :danger="!!errors.length"
                  data-testId="state-registration"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="state-registration-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div v-if="isPerson" class="vx-col w-full sm:w-5/12">
              <ValidationProvider
                name="Nome"
                :rules="
                  getValidationRules(
                    'insured-full-name',
                    'required|nome',
                    originalQuotation.prospect.name,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  :label="'Nome Completo / Nome Social'"
                  v-model="fieldsWithValidation.name"
                  id="Nome"
                  :danger="!!errors.length"
                  data-testId="insured-full-name"
                  :disabled="
                    !isInsuredMainDriverFieldEditable(
                      'insured-full-name',
                      'driver-full-name',
                    )
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-full-name-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div
              v-if="isPerson"
              class="vx-col w-full sm:w-2/12 checkBoxNomeSocial"
            >
              <vs-checkbox
                v-model="fieldsWithValidation.socialName"
                data-testId="insured-social-name-checkbox"
                :disabled="
                  !isInsuredMainDriverFieldEditable(
                    'insured-social-name-checkbox',
                    'driver-social-name-checkbox',
                  )
                "
              >
                Nome Social?
              </vs-checkbox>
            </div>

            <div
              v-if="fieldsWithValidation.socialName"
              class="vx-col w-full sm:w-5/12"
            >
              <ValidationProvider
                name="Nome Civil"
                :rules="
                  getValidationRules(
                    'insured-civil-name',
                    'required|nome',
                    originalQuotation.prospect.civil_name,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  label="Nome Civil"
                  v-model="fieldsWithValidation.civilName"
                  id="Nome Civil"
                  :danger="!!errors.length"
                  data-testId="insured-civil-name"
                  :disabled="
                    !isInsuredMainDriverFieldEditable(
                      'insured-civil-name',
                      'driver-social-name',
                    )
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-civil-name-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div v-if="isPerson" class="vx-col sm:w-1/6 w-full">
              <ValidationProvider
                name="Data de Nascimento Segurado"
                :rules="
                  getValidationRules(
                    'insured-birth-date',
                    {
                      required: true,
                      date_format: 'dd/MM/yyyy',
                      min_age: true,
                      max_age: true,
                    },
                    formatDateBr(originalQuotation.prospect.birthdate),
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  label="Data de Nascimento"
                  v-mask="'##/##/####'"
                  v-model="fieldsWithValidation.birthDate"
                  :danger="!!errors.length"
                  data-testId="insured-birth-date"
                  :disabled="
                    !isInsuredMainDriverFieldEditable(
                      'insured-birth-date',
                      'driver-birthdate',
                    )
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-birth-date-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div v-if="isPerson" class="vx-col sm:w-1/6 w-full">
              <label for="Sexo de Nascimento" class="vs-select--label">
                Sexo de Nascimento
              </label>
              <ValidationProvider
                name="Sexo Segurado"
                :rules="
                  getValidationRules(
                    'insured-gender',
                    'required',
                    originalQuotation.prospect.gender,
                  )
                "
                v-slot="{ errors }"
              >
                <v-select
                  label="label"
                  id="Sexo Segurado"
                  v-model="fieldsWithValidation.gender"
                  :options="LIST_SEXO"
                  :danger="!!errors.length"
                  data-testId="insured-gender"
                  :disabled="
                    !isInsuredMainDriverFieldEditable(
                      'insured-gender',
                      'driver-gender',
                    )
                  "
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-gender-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div v-if="isPerson" class="vx-col sm:w-1/6 w-full">
              <label for="Estado Civil" class="vs-select--label">
                Estado Civil
              </label>
              <ValidationProvider
                name="Estado Civil"
                :rules="
                  getValidationRules(
                    'insured-select-marital-status',
                    'required',
                    originalQuotation.prospect.marital_status,
                  )
                "
                v-slot="{ errors }"
              >
                <v-select
                  label="label"
                  id="Estado Civil"
                  v-model="fieldsWithValidation.maritalStatus"
                  :options="LIST_ESTADO_CIVIL"
                  :danger="!!errors.length"
                  data-testId="insured-select-marital-status"
                  :disabled="!isFieldEditable('insured-select-marital-status')"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-marital-status-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div class="vx-col sm:w-1/6 w-full">
              <div class="flex flex-row items-end w-full">
                <div class="w-full">
                  <label for="Celular" class="vs-select--label">Celular</label>
                  <ValidationProvider
                    name="Celular"
                    :rules="
                      getValidationRules(
                        'insured-cellphone',
                        'required|min:15|dddValidos|br_phone',
                        originalQuotation.prospect.cellphone,
                      )
                    "
                    v-slot="{ errors }"
                  >
                    <the-mask
                      mask="(##) #####-####"
                      id="Celular"
                      class="vs-inputx vs-input--input normal hasValue w-full"
                      v-model="fieldsWithValidation.cellphone"
                      :masked="true"
                      :danger="!!errors.length"
                      data-testId="insured-cellphone"
                      :disabled="!isFieldEditable('insured-cellphone')"
                    />
                    <span
                      v-show="!!errors.length"
                      class="text-danger"
                      data-testId="insured-cellphone-error"
                    >
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <div class="flex flex-row items-end w-full">
                <div class="w-full">
                  <ValidationProvider
                    name="Email"
                    :rules="
                      getValidationRules(
                        'insured-email',
                        {
                          required: true,
                          email: true,
                          max: 75,
                        },
                        originalQuotation.prospect.email,
                      )
                    "
                    v-slot="{ errors }"
                  >
                    <vs-input
                      name="Email"
                      class="w-full"
                      label="E-mail"
                      v-model="fieldsWithValidation.email"
                      maxlength="75"
                      :danger="!!errors.length"
                      type="email"
                      data-testId="insured-email"
                      :disabled="!isFieldEditable('insured-email')"
                    />
                    <span
                      v-show="!!errors.length"
                      class="text-danger"
                      data-testId="insured-email-error"
                    >
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isPerson" class="vx-row mb-4">
            <div class="vx-col sm:w-1/3 w-full checkBoxNomeSocial">
              <vs-checkbox
                v-model="isPoliticallyExposed"
                data-testId="politically-exposed-checkbox"
                :disabled="!isFieldEditable('politically-exposed-checkbox')"
              >
                É Uma Pessoa Politicamente Exposta (PPE)?
              </vs-checkbox>
            </div>

            <div v-if="isPoliticallyExposed" class="vx-col sm:w-2/3 w-full">
              <ValidationProvider
                name="Tipo de PPE"
                :rules="
                  getValidationRules(
                    'insured-ppe-type',
                    'required|max:60',
                    originalQuotation.prospect.is_politically_exposed,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  label="Tipo de PPE"
                  v-model="fieldsWithValidation.ppeDescription"
                  id="Tipo de PPE"
                  maxlength="60"
                  :danger="!!errors.length"
                  data-testId="insured-ppe-type"
                  :disabled="!isFieldEditable('insured-ppe-type')"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-ppe-type-error"
                  >{{ errors[0] }}</span
                ></ValidationProvider
              >
            </div>
          </div>
          <!--Fim Sessao Dados Segurado-->

          <!--Sessao Endereço Segurado-->
          <div class="form-part-title mt-6 mb-6">
            <span>Endereço do Segurado</span>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/4 w-full">
              <label for="Cep Segurado" class="vs-select--label">CEP</label>
              <ValidationProvider
                name="Cep Segurado"
                :rules="
                  getValidationRules(
                    'insured-cep',
                    'required|min:10',
                    originalQuotation.prospect.address.zip_code,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  id="Cep Segurado"
                  @keyup.native="handleCepChanges('address')"
                  v-model="fieldsWithValidation.address.zipCode"
                  maxlength="50"
                  :danger="!!errors.length"
                  v-mask="'##.###-###'"
                  data-testId="insured-cep"
                  :disabled="!isFieldEditable('insured-cep')"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-cep-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div class="vx-col sm:w-3/4 w-full">
              <label for="Endereco Segurado" class="vs-select--label">
                Logradouro
              </label>
              <ValidationProvider
                name="Logradouro Segurado"
                :rules="
                  getValidationRules(
                    'insured-street',
                    'required',
                    originalQuotation.prospect.address.street,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="fieldsWithValidation.address.street"
                  class="w-full"
                  id="Endereco Segurado"
                  :danger="!!errors.length"
                  data-testId="insured-street"
                  :disabled="
                    (hasCepApiReturnedInsured && hasCepApiReturnedStreet) ||
                    !isFieldEditable('insured-street')
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-street-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col sm:w-3/12 w-full">
              <label for="Bairro Segurado" class="vs-select--label">
                Bairro
              </label>
              <ValidationProvider
                name="Bairro Segurado"
                :rules="
                  getValidationRules(
                    'insured-neighborhood',
                    'required',
                    originalQuotation.prospect.address.neighborhood,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="fieldsWithValidation.address.neighborhood"
                  class="w-full"
                  id="Bairro Segurado"
                  :danger="!!errors.length"
                  data-testId="insured-neighborhood"
                  :disabled="
                    (hasCepApiReturnedInsured &&
                      hasCepApiReturnedNeighborhood) ||
                    !isFieldEditable('insured-neighborhood')
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-neighborhood-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div class="vx-col sm:w-2/12">
              <label for="Número Segurado" class="vs-select--label">
                Número
              </label>
              <ValidationProvider
                name="Número Segurado"
                :rules="
                  getValidationRules(
                    'insured-address-number',
                    'required|max:10',
                    originalQuotation.prospect.address.number,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  id="Número Segurado"
                  v-model="fieldsWithValidation.address.number"
                  :danger="!!errors.length"
                  data-testId="insured-address-number"
                  :disabled="!isFieldEditable('insured-address-number')"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-address-number-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div class="vx-col sm:w-2/12">
              <label for="Complemento Segurado" class="vs-select--label">
                Complemento
              </label>
              <ValidationProvider
                name="Complemento Segurado"
                :rules="
                  getValidationRules(
                    'insured-address-complement',
                    'max:40',
                    originalQuotation.prospect.address.complement,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="fieldsWithValidation.address.complement"
                  class="w-full"
                  id="Complemento Segurado"
                  maxlength="40"
                  data-testId="insured-address-complement"
                  :disabled="!isFieldEditable('insured-address-complement')"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-address-complement-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-2/12 w-full">
              <label for="Estado Segurado" class="vs-select--label"
                >Estado
              </label>
              <ValidationProvider
                name="Estado Segurado"
                :rules="
                  getValidationRules(
                    'insured-state',
                    'required',
                    originalQuotation.prospect.address.state,
                  )
                "
                v-slot="{ errors }"
              >
                <v-select
                  :options="estados"
                  id="Estado Segurado"
                  autocomplete="off"
                  @input="
                    getCityDataInsured(
                      'domMunicipio',
                      'cidades',
                      'nomeCidade',
                      'idCidade',
                    ),
                      selectStateInsured()
                  "
                  v-model="fieldsWithValidation.address.state"
                  placeholder="Selecione o Estado Segurado"
                  label="label"
                  value="id"
                  :danger="!!errors.length"
                  data-testId="insured-state"
                  :disabled="
                    (hasCepApiReturnedInsured && hasCepApiReturnedState) ||
                    !isFieldEditable('insured-state')
                  "
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-state-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-3/12 w-full">
              <label for="Cidade Segurado" class="vs-select--label">
                Cidade
              </label>
              <ValidationProvider
                name="Cidade Segurado"
                :rules="getValidationRules('insured-city', 'required')"
                v-slot="{ errors }"
              >
                <v-select
                  :options="cidades"
                  id="Cidade Segurado"
                  @input="selectCityInsured()"
                  v-model="fieldsWithValidation.address.city"
                  placeholder="Selecione a Cidade"
                  label="label"
                  :danger="!!errors.length"
                  data-testId="insured-city"
                  :disabled="
                    hasCepApiReturnedInsured || !isFieldEditable('insured-city')
                  "
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-city-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
          <!--Fim Sessao Endereço Segurado-->

          <!--Sessao Dados do Condutor-->
          <div class="form-part-title mt-6 mb-6">
            <span>Dados do Condutor</span>
          </div>

          <div class="vx-row mb-4">
            <div v-if="isPerson" class="vx-col sm:w-1/4 w-full">
              <vs-checkbox
                v-model="insuredIsMainDriver"
                data-testId="insured-is-main-driver"
                :disabled="!isFieldEditable('insured-is-main-driver-checkbox')"
              >
                Condutor é o segurado?
              </vs-checkbox>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <ValidationProvider
                name="CPF-CNPJ condutor"
                :rules="
                  getValidationRules(
                    'driver-cpf-cnpj',
                    {
                      required: true,
                      min: DOCUMENT_LENGTH_WITH_MASK.CPF,
                      cpf_cnpj: true,
                    },
                    originalQuotation.driver.tax_id,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="fieldsWithValidation.driverCpfCnpj"
                  class="w-full"
                  label="CPF"
                  id="CPF-CNPJ condutor"
                  v-mask="DOCUMENT_MASK.CPF_ONLY"
                  :danger="!!errors.length"
                  data-testId="driver-cpf-cnpj"
                  :disabled="
                    insuredIsMainDriver || !isFieldEditable('driver-cpf-cnpj')
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="driver-cpf-cnpj-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div
              v-if="
                fieldsWithValidation.driverCpfCnpj.length >=
                DOCUMENT_LENGTH_WITH_MASK.CPF
              "
              class="vx-col sm:w-1/4 w-full"
            >
              <ValidationProvider
                name="Data de Nascimento"
                :rules="
                  getValidationRules(
                    'driver-birthdate',
                    'required|date_format:dd/MM/yyyy|min_age|max_age',
                    formatDateBr(originalQuotation.driver.birthdate),
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  name="Data de Nascimento"
                  class="w-full"
                  label="Data de Nascimento"
                  v-mask="'##/##/####'"
                  v-model="fieldsWithValidation.driverBirthdate"
                  :danger="!!errors.length"
                  data-testId="driver-birthdate"
                  :disabled="
                    insuredIsMainDriver || !isFieldEditable('driver-birthdate')
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="driver-birthdate-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div
              v-if="
                fieldsWithValidation.driverCpfCnpj.length >=
                DOCUMENT_LENGTH_WITH_MASK.CPF
              "
              class="vx-col sm:w-1/4 w-full"
            >
              <label for="Tipo de CNH" class="vs-select--label">
                Sexo de Nascimento
              </label>
              <ValidationProvider
                name="Sexo"
                :rules="
                  getValidationRules(
                    'driver-gender',
                    'required',
                    originalQuotation.driver.gender,
                  )
                "
                v-slot="{ errors }"
              >
                <v-select
                  label="label"
                  id="Sexo"
                  v-model="fieldsWithValidation.driverGender"
                  :options="LIST_SEXO"
                  :danger="!!errors.length"
                  data-testId="driver-gender"
                  :disabled="
                    insuredIsMainDriver || !isFieldEditable('driver-gender')
                  "
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="driver-gender-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div
            v-if="
              fieldsWithValidation.driverCpfCnpj.length >=
              DOCUMENT_LENGTH_WITH_MASK.CPF
            "
            class="vx-row mb-4"
          >
            <div class="vx-col w-full sm:w-5/12">
              <ValidationProvider
                name="NomeCondutor"
                :rules="
                  getValidationRules(
                    'driver-full-name',
                    'required|is-person-name',
                    originalQuotation.driver.name,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  label="Nome Completo / Nome Social"
                  v-model="fieldsWithValidation.driverName"
                  id="NomeCondutor"
                  :danger="!!errors.length"
                  data-testId="driver-full-name"
                  :disabled="
                    insuredIsMainDriver || !isFieldEditable('driver-full-name')
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="driver-full-name-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div
              v-if="
                fieldsWithValidation.driverCpfCnpj.length >=
                DOCUMENT_LENGTH_WITH_MASK.CPF
              "
              class="vx-col w-full sm:w-2/12 checkBoxNomeSocial"
            >
              <vs-checkbox
                v-model="fieldsWithValidation.driverSocialName"
                data-testId="driver-social-name-checkbox"
                :disabled="
                  insuredIsMainDriver ||
                  !isFieldEditable('driver-social-name-checkbox')
                "
              >
                Nome Social?
              </vs-checkbox>
            </div>

            <div
              v-if="fieldsWithValidation.driverSocialName"
              class="vx-col w-full sm:w-5/12"
            >
              <ValidationProvider
                name="Nome Civil Condutor"
                :rules="
                  getValidationRules(
                    'driver-social-name',
                    'required|is-person-name',
                    originalQuotation.driver.civil_name,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  label="Nome Civil Condutor"
                  v-model="fieldsWithValidation.driverCivilName"
                  id="Nome Civil Condutor"
                  data-testId="driver-social-name"
                  :disabled="
                    insuredIsMainDriver ||
                    !isFieldEditable('driver-social-name')
                  "
                  :danger="!!errors.length"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="driver-social-name-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <ValidationProvider
                name="Email Condutor"
                :rules="
                  getValidationRules(
                    'driver-email',
                    'email|max:75',
                    originalQuotation.driver.email,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  label="E-mail"
                  v-model="fieldsWithValidation.driverEmail"
                  maxlength="75"
                  :danger="!!errors.length"
                  :disabled="!isFieldEditable('driver-email')"
                  type="email"
                  data-testId="driver-email"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="driver-email-error"
                >
                  {{ errors[0] }}
                </span></ValidationProvider
              >
            </div>
          </div>
          <!--Fim Sessao Dados do Condutor-->

          <!--Sessao Endereço Pernoite-->
          <div class="form-part-title mt-6 mb-6">
            <span>CEP de Pernoite</span>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/4 w-full">
              <label for="CEP" class="vs-select--label">CEP</label>
              <ValidationProvider
                name="CEP"
                :rules="
                  getValidationRules(
                    'overnight-cep',
                    'required|min:10',
                    originalQuotation.overnight_address.zip_code,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  id="CEP"
                  @keyup.native="handleCepChanges('overnightAddress')"
                  v-model="fieldsWithValidation.overnightAddress.zipCode"
                  :danger="!!errors.length"
                  v-mask="'##.###-###'"
                  data-testId="overnight-cep"
                  :disabled="!isFieldEditable('overnight-cep')"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-cep-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div
              v-if="fieldsWithValidation.overnightAddress.zipCode.length === 10"
              class="vx-col sm:w-3/4 w-full"
            >
              <label for="Endereco" class="vs-select--label">Logradouro</label>
              <ValidationProvider
                name="Logradouro"
                :rules="
                  getValidationRules(
                    'overnight-street',
                    'required',
                    originalQuotation.overnight_address.street,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="fieldsWithValidation.overnightAddress.street"
                  class="w-full"
                  id="Endereco"
                  data-testId="overnight-street"
                  :danger="!!errors.length"
                  :disabled="
                    hasCepApiReturnedOvernightStreet ||
                    !isFieldEditable('overnight-street')
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-street-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
          <div
            v-if="fieldsWithValidation.overnightAddress.zipCode.length === 10"
            class="vx-row mb-4"
          >
            <div class="vx-col sm:w-3/12 w-full">
              <label for="Bairro" class="vs-select--label">Bairro</label>
              <ValidationProvider
                name="Bairro"
                :rules="
                  getValidationRules(
                    'overnight-neighborhood',
                    'required',
                    originalQuotation.overnight_address.neighborhood,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="fieldsWithValidation.overnightAddress.neighborhood"
                  class="w-full"
                  id="Bairro"
                  data-testId="overnight-neighborhood"
                  :danger="!!errors.length"
                  :disabled="
                    hasCepApiReturnedOvernightNeighborhood ||
                    !isFieldEditable('overnight-neighborhood')
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-neighborhood-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-2/12">
              <label for="Número" class="vs-select--label">Número</label>
              <ValidationProvider
                name="Número"
                :rules="
                  getValidationRules(
                    'overnight-number',
                    'max:10',
                    originalQuotation.overnight_address.number,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  id="Número"
                  v-model="fieldsWithValidation.overnightAddress.number"
                  :danger="!!errors.length"
                  data-testId="overnight-number"
                  :disabled="!isFieldEditable('overnight-number')"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-number-hood"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-2/12">
              <label for="Complemento Pernoite" class="vs-select--label">
                Complemento
              </label>
              <ValidationProvider
                name="Complemento Pernoite"
                :rules="
                  getValidationRules(
                    'overnight-address-complement',
                    'max:40',
                    originalQuotation.overnight_address.complement,
                  )
                "
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="fieldsWithValidation.overnightAddress.complement"
                  class="w-full"
                  id="Complemento Pernoite"
                  maxlength="40"
                  data-testId="overnight-address-complement"
                  :disabled="!isFieldEditable('overnight-address-complement')"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-address-complement-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-2/12">
              <label for="Estado" class="vs-select--label">Estado</label>
              <ValidationProvider
                name="Estado"
                :rules="
                  getValidationRules(
                    'overnight-state',
                    'required|estado_pernoite',
                    originalQuotation.overnight_address.state,
                  )
                "
                v-slot="{ errors }"
              >
                <v-select
                  :options="estados"
                  id="Estado"
                  autocomplete="off"
                  @input="
                    getCityData(
                      'domMunicipio',
                      'cidades',
                      'nomeCidade',
                      'idCidade',
                    ),
                      selectState()
                  "
                  v-model="fieldsWithValidation.overnightAddress.state"
                  placeholder="Selecione o Estado"
                  label="label"
                  data-testId="overnight-state"
                  :danger="!!errors.length"
                  :disabled="
                    hasCepApiReturnedOvernightState ||
                    !isFieldEditable('overnight-state')
                  "
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-state-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-3/12">
              <label for="Cidade" class="vs-select--label">Cidade</label>
              <ValidationProvider
                name="Cidade"
                :rules="getValidationRules('overnight-city', 'required')"
                v-slot="{ errors }"
              >
                <v-select
                  :options="cidades"
                  id="Cidade"
                  @input="selectCity()"
                  v-model="fieldsWithValidation.overnightAddress.city"
                  placeholder="Selecione a Cidade"
                  label="label"
                  data-testId="overnight-city"
                  :danger="!!errors.length"
                  :disabled="
                    hasCepApiReturnedOvernightCity ||
                    !isFieldEditable('overnight-city')
                  "
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-city-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
          <!-- Fim Sessao Endereço Pernoite-->

          <!--Sessao dados do veiculo-->
          <div class="form-part-title mt-6 mb-6">
            <span>Dados do Veículo</span>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/6 w-full">
              <vs-checkbox
                v-model="isBrandNew"
                @change="clearAllVehicleData()"
                data-testId="zero-vehicle-checkbox"
                :disabled="!isFieldEditable('zero-vehicle-checkbox')"
              >
                Veículo Zero
              </vs-checkbox>
              <span
                v-show="hasZeroKmError"
                class="text-danger"
                data-testId="zero-vehicle-checkbox-error"
              >
                Veículo não pode ser 0 km
              </span>
            </div>

            <div class="vx-col sm:w-1/5 w-full">
              <label for="" class="vs-select--label">Placa</label>
              <ValidationProvider
                name="Placa"
                :rules="
                  getValidationRules(
                    'vehicle-plate',
                    {
                      // required: showPlate,
                      length: 8,
                    },
                    originalQuotation.vehicle.plate,
                  )
                "
                v-slot="{ errors }"
                ><the-mask
                  mask="AAA-#XX#"
                  style="text-transform: uppercase"
                  id="input-2"
                  class="vs-inputx vs-input--input normal hasValue w-full"
                  v-model="fieldsWithValidation.vehiclePlate"
                  :masked="true"
                  :danger="!!errors.length"
                  @input="keymonitorPlate"
                  :disabled="disablePlate || !isFieldEditable('vehicle-plate')"
                />
                <span v-show="!!errors.length" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <ValidationProvider
                name="Chassi"
                :rules="
                  getValidationRules(
                    'vehicle-chassis',
                    'min:17|max:17',
                    originalQuotation.vehicle.chassis,
                  )
                "
                v-slot="{ errors }"
                ><vs-input
                  class="vs-inputx normal hasValue w-full"
                  label="Chassi"
                  v-model="fieldsWithValidation.vehicleChassis"
                  id="Chassi"
                  maxlength="17"
                  :danger="!!errors.length"
                  data-testId="vehicle-chassis"
                  :disabled="
                    disableChassis || !isFieldEditable('vehicle-chassis')
                  "
                  @input="keymonitorChassi"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="vehicle-chassis-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div v-if="!showPlate" class="vx-col sm:w-1/5 w-full">
              <ValidationProvider
                name="Nº da nota fiscal"
                :rules="
                  getValidationRules(
                    'vehicle-invoice-number',
                    originalQuotation.vehicle.invoice_number,
                  )
                "
                v-slot="{ errors }"
                ><vs-input
                  class="w-full"
                  label="Nº da nota fiscal"
                  v-mask="'####################'"
                  v-model="fieldsWithValidation.vehicleInvoiceNumber"
                  id="numeroNf"
                  :danger="!!errors.length"
                  :disabled="!isFieldEditable('vehicle-invoice-number')"
                  data-testId="vehicle-invoice-number"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="vehicle-invoice-number-error"
                  >{{ errors[0] }}</span
                ></ValidationProvider
              >
            </div>

            <div v-if="!showPlate" class="vx-col sm:w-1/5 w-full">
              <ValidationProvider
                name="Data de emissão da nota fiscal"
                :rules="getInvoiceDateRules()"
                v-slot="{ errors }"
                ><vs-input
                  class="w-full"
                  label="Data de emissão da nota fiscal"
                  v-mask="'##/##/####'"
                  v-model="fieldsWithValidation.vehicleInvoiceDate"
                  id="dataSaidaNF"
                  :danger="!!errors.length"
                  :disabled="!isFieldEditable('vehicle-invoice-date')"
                  data-testId="vehicle-invoice-date"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="vehicle-invoice-date-error"
                  >{{ errors[0] }}</span
                ></ValidationProvider
              >
            </div>
          </div>

          <div class="vx-row mb-4">
            <div v-if="!showPlate" class="vx-col sm:w-1/5 w-full">
              <label
                for="Veículo saiu da concessionária"
                class="vs-select--label"
              >
                Veículo saiu da concessionária?
              </label>
              <ValidationProvider
                name="Veículo saiu da concessionária"
                :rules="
                  getValidationRules(
                    'vehicle-is-outdealership-checkbox',
                    originalQuotation.vehicle.out_daelership,
                  )
                "
                v-slot="{ errors }"
              >
                <v-select
                  name="Veículo saiu da concessionária"
                  :options="outOfDealershipOptions"
                  id="Veículo saiu da concessionária"
                  v-model="fieldsWithValidation.vehicleIsOutOfDealership"
                  :reduce="(item) => item.value"
                  :danger="!!errors.length"
                  :disabled="
                    !isFieldEditable('vehicle-is-outdealership-checkbox')
                  "
                  data-testId="vehicle-is-outdealership-checkbox"
                ></v-select>
                <span v-show="!!errors.length" class="text-danger"
                  >{{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div
              v-if="
                isBrandNew === true &&
                fieldsWithValidation.vehicleIsOutOfDealership === true
              "
              class="vx-col sm:w-1/5 w-full"
            >
              <ValidationProvider
                name="Data de saída da concessionária"
                :rules="
                  getValidationRules(
                    'dealership-exit-date',
                    'less_than_today|after_invoice_date|date_format:dd/MM/yyyy',
                    formatDateNoTime(
                      originalQuotation.vehicle.dealership_exit_date,
                    ),
                  )
                "
                v-slot="{ errors }"
              >
                <label
                  for="Data de saída da concessionária"
                  class="vs-select--label"
                >
                  Data de saída da concessionária
                </label>
                <div class="flex w-full gap-2 items-center">
                  <vs-input
                    class="w-full"
                    v-mask="'##/##/####'"
                    v-model="fieldsWithValidation.dealershipExitDate"
                    name="Data de saída da concessionária"
                    id="dealershipExitDate"
                    :danger="!!errors.length"
                    :disabled="!isFieldEditable('dealership-exit-date')"
                    data-testId="dealership-exit-date"
                  />
                </div>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="dealership-exit-date-error"
                  >{{ errors[0] }}</span
                ></ValidationProvider
              >
            </div>
            <div
              v-if="isBrandNew && !!exitDateTooltipText"
              class="vx-col sm:w-1/12 px-0"
            >
              <vs-icon
                v-tooltip="exitDateTooltipText"
                icon="help"
                size="small"
                color="primary"
                class="mt-8"
              ></vs-icon>
            </div>
            <div
              v-if="invoiceDocument"
              class="vx-col sm:w-1/4 w-full flex items-center justify-start"
            >
              <a :href="invoiceDocument" download> Download da nota fiscal </a>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div v-if="!selectedFipeModel" class="vx-col sm:w-1/4 w-full">
              <label for="" class="vs-select--label">Marca</label>
              <ValidationProvider
                name="Marca"
                :rules="
                  getManualVehicleValidationRules(
                    'vehicle-brand',
                    'required',
                    originalQuotation.vehicle.brand_id,
                  )
                "
                v-slot="{ errors }"
                ><v-select
                  :options="vehicleBrands"
                  id="Marca"
                  @input="getVehicleModels()"
                  v-model="fieldsWithValidation.vehicleBrandId"
                  label="label"
                  data-testId="vehicle-brand"
                  :disabled="!isFieldEditable('vehicle-brand')"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="vehicle-brand-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>

            <div v-if="!selectedFipeModel" class="vx-col sm:w-1/4 w-full">
              <label for="" class="vs-select--label">Modelo</label>
              <ValidationProvider
                name="Modelo"
                :rules="
                  getManualVehicleValidationRules(
                    'vehicle-model',
                    'required',
                    originalQuotation.vehicle.model_id,
                  )
                "
                v-slot="{ errors }"
              >
                <v-select
                  :options="vehicleModels"
                  id="Modelo"
                  @input="getVehicleYears()"
                  v-model="fieldsWithValidation.vehicleModelId"
                  label="label"
                  data-testId="vehicle-model"
                  :disabled="!isFieldEditable('vehicle-model')"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="vehicle-model-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>

            <div v-if="!selectedFipeModel" class="vx-col sm:w-1/4 w-full">
              <label for="" class="vs-select--label">Ano Modelo</label>
              <ValidationProvider
                name="Ano Modelo"
                :rules="
                  getManualVehicleYearValidationRules(
                    'vehicle-model-year',
                    'required',
                    originalQuotation.vehicle.year_model,
                  )
                "
                v-slot="{ errors }"
              >
                <v-select
                  :options="vehicleYearsModel"
                  id="Ano Modelo"
                  @input="getVehicleModelsByYear()"
                  v-model="fieldsWithValidation.vehicleYearModel"
                  label="label"
                  data-testId="vehicle-model-year"
                  :disabled="!isFieldEditable('vehicle-model-year')"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="vehicle-year-model-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>

            <div v-if="selectedFipeModel" class="vx-col w-full">
              <vs-alert
                active="true"
                class="vehicle-alert text-light mt-3 mb-3"
              >
                <div class="w-full flex vs-align-center">
                  <p class="w-full p-3">
                    {{ vehicleResult.brand }}/{{
                      selectedFipeModel.model_text
                    }}
                    - {{ vehicleResult.year }}/{{
                      selectedFipeModel.year_model
                    }}
                  </p>
                  <vs-button
                    v-if="isVehicleEditable()"
                    color="primary"
                    type="flat"
                    icon="cached"
                    size="large"
                    @click="showSelectPlateModal = true"
                    data-testId="vehicle-refresh"
                  ></vs-button>
                </div>
              </vs-alert>
            </div>
          </div>

          <div v-if="fieldsWithValidation.fipeResult" class="vx-row mb-4">
            <div class="vx-col sm:w-1/2 w-full">
              <label for class="vs-input--label">Preço FIPE</label>
              <ValidationProvider
                name="Preço FIPE"
                :rules="
                  getFipeValueValidationRules(
                    'vehicle-fipe-value',
                    'required',
                    originalQuotation.vehicle.fipe_result.amount,
                  )
                "
                v-slot="{ errors }"
              >
                <money
                  class="vs-inputx vs-input--input normal"
                  id="Preço FIPE"
                  v-model="fieldsWithValidation.fipeResult.amount"
                  v-bind="money"
                  :danger="!!errors.length"
                  disabled
                  data-testId="vehicle-fipe-value"
                ></money>
                <span v-show="!!errors.length" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div class="vx-col sm:w-1/2 w-full container">
              <label>
                Código FIPE:
                <span class="font-bold">
                  {{
                    vehicleFipeCode
                      ? vehicleFipeCode
                      : fieldsWithValidation.fipeResult.fipe_code
                  }}
                </span>
              </label>
            </div>
          </div>
          <!--FIm Sessao Endereço Pernoite-->

          <!--Questionario de riscos-->
          <div v-if="increases.length" class="form-part-title mt-6 mb-6">
            <span>Questionário de Avaliação de Risco</span>
          </div>

          <div v-if="increases.length" class="vx-row mb-4">
            <div
              v-for="(item, index) in increases"
              :key="index"
              class="vx-col sm:w-1/3 w-full mb-"
            >
              <label
                :for="item.question"
                class="vs-select--label"
                :data-testId="`increase-label-${item.id}`"
              >
                {{ item.question }}
              </label>
              <ValidationProvider
                :name="item.question"
                :rules="
                  isFieldEditable(`increase-answer-'select'`) ? required : ''
                "
                v-slot="{ errors }"
              >
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  :data-testId="`error-${item.id}`"
                >
                  {{ errors[0] }}
                </span>
                <v-select
                  :options="item.answers"
                  :id="item.question"
                  v-model="fieldsWithValidation.increasesAnswers[item.id]"
                  label="response"
                  placeholder="Selecione"
                  :danger="!!errors.length"
                  :data-testId="`select-${item.id}`"
                  :disabled="!isFieldEditable(`increase-answer-select`)"
                ></v-select>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full">
              <ValidationProvider
                name="Questionário de avaliação de risco"
                :rules="
                  getIncreasesValidationRules(
                    `increase-answer-select`,
                    'required',
                  )
                "
                v-slot="{ errors }"
              >
                <vs-select
                  style="display: none"
                  disabled
                  v-model="fieldsWithValidation.increasesAnswers"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  :data-testId="`error-increases`"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
          <!--Fim questionario de riscos-->

          <!--sessão Produtos-->
          <div v-if="isEdition">
            <div class="form-part-title mt-6 mb-6">
              <span>Produtos e Prêmio</span>
            </div>

            <div class="flex flex-col gap-16 lg:gap-18 mb-4">
              <ValidationProvider
                name="Produtos e Prêmio"
                :rules="getProductsValidationRules(`carregamentos-form`, {})"
                v-slot="{ errors }"
              >
                <ProductsList
                  v-model="fieldsWithValidation.selectedProducts"
                  :products="products"
                  :selectedProducts="fieldsWithValidation.selectedProducts"
                  :disabled="!isFieldEditable('carregamentos-form')"
                  @update:selectedProducts="updateSelectedProducts"
                  @update:isValidRcfValue="updateIsValidRcfValue"
                ></ProductsList>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  :data-testId="`error-products`"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>

              <CarregamentosForm
                :formData="form"
                :premio="prize ? prize.tariff_prize : 0"
                :enableDiscount="true"
                :isCanceled="true"
                ref="CarregamentosForm"
                parent="1"
                :brokerId="fieldsWithValidation.brokerId"
                data-testId="carregamentos-form"
                :brokerAccountBalanceInsufficient="
                  brokerAccountBalanceInsufficient
                "
                :brokerAccountBalanceUsed="brokerAccountBalanceUsed"
                :nextMonthDiscountMessage="null"
                :shouldValidateDiscount="false"
              />
            </div>
          </div>
          <!--fim sessão Produtos-->

          <div class="vx-col w-full text-right">
            <vs-button
              v-if="!isQuotationBlocked() && hasWritePermission"
              type="filled"
              @click.stop.prevent="createQuotation()"
              color="success"
              class="mt-2 mb-2 botaoContratarAgora"
              :class="isLanding ? 'w-full' : ''"
              :pill="isLanding ? true : false"
              :disabled="invalid || hasZeroKmError"
              data-testId="generate-quotation-button"
            >
              <span>Gerar cotação de Endosso</span>
            </vs-button>
            <vs-button
              v-else
              type="filled"
              @click.stop.prevent="step = 1"
              color="success"
              class="mt-2 mb-2 botaoContratarAgora"
              :class="isLanding ? 'w-full' : ''"
              :pill="isLanding ? true : false"
              data-testId="quotation-result-button"
            >
              <span>Resultado do Endosso</span>
            </vs-button>
          </div>
        </div>

        <div v-if="step === 1 && quotation && quotation.endorsement">
          <div
            class="form-part-title mt-6 mb-6"
            v-if="
              quotation.endorsement.prize &&
              quotation.endorsement.prize.prize > 0
            "
          >
            <span>Dados do Pagamento</span>
          </div>

          <div class="w-full mb-6 lg:py-2 xl:py-4 2xl:py-10">
            <div
              class="vx-row"
              v-if="
                quotation.endorsement.prize &&
                quotation.endorsement.prize.prize > 0 &&
                !isQuotationBlocked()
              "
            >
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <span>Forma de Pagamento</span>
                <ValidationProvider
                  name="Forma de Pagamento"
                  rules="required"
                  v-slot="{ errors }"
                  ><v-select
                    :options="paymentMethods"
                    id="Forma de Pagamento"
                    label="paymentName"
                    v-model="fieldsWithValidation.selectedPayment"
                    @input="changePaymentMethod"
                    :danger="!!errors.length"
                    data-testId="payment-methods-select"
                    :disabled="isQuotationBlocked() || !hasWritePermission"
                  ></v-select>
                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="payment-methods-select-error"
                  >
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div
                v-if="
                  fieldsWithValidation.selectedPayment &&
                  fieldsWithValidation.selectedPayment.paymentMethodId !==
                    PAYMENT_METHODS.CREDIT_CARD.id
                "
                class="vx-col sm:w-1/2 w-full mb-2"
              >
                <label for="Nº de Parcelas" class="vs-select--label">
                  Nº de Parcelas
                </label>
                <ValidationProvider
                  name="Nº de Parcelas"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :options="installments"
                    id="Nº de Parcelas"
                    v-model="fieldsWithValidation.payment.installments"
                    label="label"
                    value="id"
                    @input="recalculateEndorsement()"
                    :danger="!!errors.length"
                    data-testId="installments-select"
                    :disabled="isQuotationBlocked() || !hasWritePermission"
                  />
                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="installments-select-error"
                  >
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div v-if="showDueDay" class="vx-col sm:w-1/4 w-full mb-2">
                <label for="Dia do Vencimento" class="vs-select--label"
                  >Dia do Vencimento</label
                >
                <ValidationProvider
                  :key="showDueDay"
                  name="Dia do Vencimento"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :options="dueDays"
                    id="Dia do Vencimento"
                    v-model="fieldsWithValidation.payment.dueDay"
                    :danger="!!errors.length"
                    data-testId="due-day-select"
                    :disabled="isQuotationBlocked() || !hasWritePermission"
                  ></v-select>
                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="due-day-select-error"
                  >
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>

            <div
              class="vx-row"
              v-if="
                quotation.endorsement.prize &&
                quotation.endorsement.prize.prize > 0 &&
                isQuotationBlocked()
              "
            >
              <div v-if="paymentText" class="vx-col sm:w-1/4 w-full mb-2">
                <span>Forma de Pagamento</span>
                <ValidationProvider
                  name="Forma de Pagamento"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    v-model="paymentText"
                    :value="paymentText"
                    class="w-full"
                    id="Forma de Pagamento"
                    disabled
                    data-testId="payment-methods-select"
                  />
                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="installments-select-error"
                    >{{ errors[0] }}</span
                  >
                </ValidationProvider>
              </div>
              <div
                v-if="
                  installmentsText &&
                  (quotation.payment.payment_method_id !==
                    PAYMENT_METHODS.CREDIT_CARD.id ||
                    hasPaidCheckout)
                "
                class="vx-col sm:w-1/2 w-full mb-2"
              >
                <label for="Nº de Parcelas" class="vs-select--label">
                  Nº de Parcelas
                </label>
                <ValidationProvider
                  name="Nº de Parcelas"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    v-model="installmentsText"
                    :value="installmentsText"
                    class="w-full"
                    id="Nº de Parcelas"
                    disabled
                    data-testId="installments-select"
                  />
                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="installments-select-error"
                    >{{ errors[0] }}</span
                  ></ValidationProvider
                >
              </div>
              <div v-if="dueDateText" class="vx-col sm:w-1/4 w-full mb-2">
                <label for="Dia do Vencimento" class="vs-select--label">
                  Dia do Vencimento
                </label>
                <ValidationProvider
                  name="Dia do Vencimento"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    v-model="dueDateText"
                    :value="dueDateText"
                    class="w-full"
                    id="Dia do Vencimento"
                    disabled
                    data-testId="due-day-select"
                  />
                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="due-day-select-error"
                    >{{ errors[0] }}</span
                  ></ValidationProvider
                >
              </div>
            </div>

            <div class="mt-8">
              <FinancialSummary
                :prize="quotation.endorsement.prize"
                isProposition
              />
            </div>
            <div class="mt-8" v-if="shouldShowRefundSection">
              <div
                v-if="shouldShowRefundCompensation"
                class="form-part-title mb-6"
              >
                <span>Forma de restituição</span>
              </div>

              <vs-alert
                v-if="isCancellationEndorsement"
                active="true"
                color="primary"
                class="mb-6"
              >
                Informe os dados bancários para restituição ao segurado.
              </vs-alert>

              <template v-else-if="shouldShowRefundCompensation">
                <vs-alert
                  v-if="isLoadingRefundCompensation"
                  active="true"
                  color="primary"
                  class="mb-6"
                >
                  Carregando os dados de restituição.
                </vs-alert>

                <vs-alert
                  v-else-if="refundCompensationError"
                  active="true"
                  color="danger"
                  class="mb-6"
                >
                  {{ refundCompensationError }}
                </vs-alert>

                <vs-alert
                  v-else-if="!refundCompensationScenario"
                  active="true"
                  color="warning"
                  class="mb-6"
                >
                  Nenhuma informação de compensação da restituição foi retornada
                  para este endosso.
                </vs-alert>

                <template v-else>
                  <EndorsementRefundScenarioAlert
                    :scenario="refundCompensationScenario"
                  />

                  <div class="mt-6" v-if="shouldShowImpactedInstallments">
                    <ImpactedInstallmentsList
                      :items="formattedImpactedInstallments"
                    />
                  </div>

                  <div class="mt-6">
                    <RefundCompensationSummary
                      :compensation-data="refundCompensationData"
                    />
                  </div>
                </template>
              </template>

              <div class="mt-6" v-if="shouldShowRefundPayoutForm">
                <RefundPayoutForm
                  :value="fieldsWithValidation.refundData"
                  :refund-bank-options="refundBankOptions"
                  :disabled="isQuotationBlocked() || !hasWritePermission"
                  @input="fieldsWithValidation.refundData = $event"
                  @search-bank="debounceBankSearch"
                  :shouldShowRefundPayoutDisclaimer="
                    shouldShowRefundPayoutDisclaimer
                  "
                />
              </div>
            </div>

            <div
              v-if="
                fieldsWithValidation.selectedPayment &&
                fieldsWithValidation.selectedPayment.id ===
                  PAYMENT_METHODS.AUTOMATIC_DEBIT.id
              "
              class="vx-row"
            >
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <label for="Banco" class="vs-select--label">Banco</label>
                <ValidationProvider
                  name="Banco"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :options="banks"
                    id="Banco"
                    v-model="fieldsWithValidation.payment.automaticDebit.bank"
                    :danger="!!errors.length"
                    data-testId="automatic-debit-bank-select"
                  ></v-select>
                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="automatic-debit-bank-select-error"
                    >{{ errors[0] }}</span
                  ></ValidationProvider
                >
              </div>

              <div class="vx-col sm:w-1/3 w-full mb-2">
                <label for="Agência" class="vs-select--label">Agência</label>
                <ValidationProvider
                  name="Agência"
                  rules="required|max:4"
                  v-slot="{ errors }"
                  ><vs-input
                    v-model="fieldsWithValidation.payment.automaticDebit.agency"
                    class="w-full"
                    id="Agência"
                    v-mask="'####'"
                    :danger="!!errors.length"
                    data-testId="automatic-debit-agency-select"
                  />
                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="automatic-debit-agency-select-error"
                    >{{ errors[0] }}</span
                  ></ValidationProvider
                >
              </div>

              <div
                class="vx-col flex flex-row sm:w-1/3 w-full mb-2 justify-between"
              >
                <div class="w-7/12">
                  <label for="Conta Corrente" class="vs-select--label"
                    >Conta Corrente</label
                  >
                  <ValidationProvider
                    name="Conta Corrente"
                    rules="required|max:20"
                    v-slot="{ errors }"
                  >
                    <vs-input
                      v-model="
                        fieldsWithValidation.payment.automaticDebit.account
                      "
                      class="w-full"
                      id="Conta Corrente"
                      v-mask="'####################'"
                      :danger="!!errors.length"
                      data-testId="automatic-debit-account-select"
                    />
                    <span
                      v-show="!!errors.length"
                      class="text-danger"
                      data-testId="automatic-debit-account-select-error"
                      >{{ errors[0] }}</span
                    ></ValidationProvider
                  >
                </div>
                <div class="w-4/12">
                  <label for="Digito" class="vs-select--label">Digito</label>
                  <ValidationProvider
                    name="Digito"
                    rules="required|max:2"
                    v-slot="{ errors }"
                    ><vs-input
                      v-model="
                        fieldsWithValidation.payment.automaticDebit.accountDigit
                      "
                      class="w-full"
                      id="Digito"
                      v-mask="'#'"
                      :danger="!!errors.length"
                      data-testId="automatic-debit-account-digit-select"
                    />
                    <span
                      v-show="!!errors.length"
                      class="text-danger"
                      data-testId="automatic-debit-account-digit-select-error"
                      >{{ errors[0] }}</span
                    ></ValidationProvider
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col w-full flex justify-between">
            <vs-button
              type="filled"
              @click.stop.prevent="moveToEndorsementDetails()"
              color="primary"
              class="mt-2 mb-2"
              :class="isLanding ? 'w-full' : ''"
              :pill="isLanding ? true : false"
              data-testId="quotation-data-button"
            >
              <span v-if="!isQuotationBlocked() && hasWritePermission"
                >Editar endosso</span
              >
              <span v-else>Dados do endosso</span>
            </vs-button>

            <vs-button
              v-if="quotation.status_id === STATUS_PROPOSTA.EM_TRANSMISSAO.id"
              type="filled"
              @click.stop.prevent="createQuotation(true)"
              color="dark"
              class="mt-2 mb-2"
              :class="isLanding ? 'w-full' : ''"
              :pill="isLanding ? true : false"
              data-testId="transmit-quotation-button"
              :disabled="
                isQuotationBlocked() ||
                invalid ||
                hasZeroKmError ||
                !isRefundCompensationReady ||
                !hasWritePermission
              "
            >
              <span>Contratar Endosso</span>
            </vs-button>
          </div>
        </div>
      </vx-card>

      <Modal
        class="holamundo"
        title="Data de saída da nota fiscal inválida"
        :active.sync="modalInfoDataSaidaNf"
        @close="modalInfoDataSaidaNf = false"
        data-testId="nf-date-invalid-popup"
      >
        A data da nota fiscal deve ser menor ou igual a hoje.
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              @click="modalInfoDataSaidaNf = false"
              type="gradient"
              color="warning"
              class="mt-5"
              data-testId="nf-date-invalid-understood-button"
            >
              <feather-icon
                class="text-white"
                icon="CheckIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              Entendi
            </vs-button>
          </div>
        </div>
      </Modal>

      <Modal
        class="holamundo"
        title="Cotação Recusada"
        :active.sync="showQuotationDeniedModal"
        @close="redirectListQuotationPage()"
        data-testId="quotation-denied-popup"
      >
        {{ proposalResponseReason }}.
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              @click="redirectListQuotationPage()"
              type="gradient"
              color="warning"
              class="mt-5"
              data-testId="quotation-denied-close-popup-button"
            >
              <feather-icon
                class="text-white"
                icon="CheckIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              Fechar
            </vs-button>
          </div>
        </div>
      </Modal>

      <ModalSelectVehicleModel
        :vehicle-model-options="plateApiFipeOptions"
        :reset="resetModalVehicleModel"
        @confirm="setVehicleAndCalculate"
        :active="showSelectPlateModal"
      />
    </div>

    <ModalHistoricoMensageria
      v-if="quotation && quotation.endorsement"
      :active.sync="historyMessagingActive"
      :dadosProposta="{
        idApolice: quotation.id,
        dadosCliente: { idProspect: quotation.prospect.id },
      }"
      @close="closeMessagingModal()"
    />
    <ModalProposalHistory
      v-if="quotation && quotation.endorsement"
      :key="`alterations-history-${quotation.proposal_id}`"
      :active.sync="historyAlterationsActive"
      :proposal-id="Number(quotation.proposal_id)"
      @close="historyAlterationsActive = false"
    />
  </ValidationObserver>
</template>
<script>
import bankApi from '@/services/bank.api';
import ModalProposalHistory from '@/views/modais/ModalProposalHistory.vue';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { debounce } from 'lodash';
import moment from 'moment';
import { Money } from 'v-money';
import {
  ValidationObserver,
  ValidationProvider,
  Validator,
} from 'vee-validate';
import flatPickr from 'vue-flatpickr-component';
import vSelect from 'vue-select';
import { DDD_BRASIL } from '../../../../common/constant/dddsValidos';
import Modal from '../../../components/Modal.vue';
import {
  DOCUMENT_LENGTH_WITH_MASK,
  DOCUMENT_MASK,
} from '../../../constants/cpfCnpj.js';
import {
  PERMISSIONS_ACTIONS,
  PERMISSIONS_NAMES,
} from '../../../constants/permissions.js';
import service from '../../../services';
import autoApi from '../../../services/auto.api';
import cpfcnpj from '../../../services/cpfCnpj.js';
import endorsementApi from '../../../services/endorsement.api';
import lifeApi from '../../../services/life-api';
import paymentMethodConfigApi from '../../../services/payment.method.config.api';
import policyApi from '../../../services/policy.api';
import {
  CONGENERS,
  FUEL_TYPE_CODES,
  FUEL_TYPE_NAMES,
  LIST_ESTADO_CIVIL,
  LIST_SEXO,
  PAYMENT_METHODS,
  POLICY_STATUSES,
  STATUS_PROPOSTA,
  TIPOS_APOLICES,
  ZERO_KM_VEHICLE_YEAR_ID,
} from '../../../utils/constants';
import dateConversion from '../../../utils/dateConversion';
import functions from '../../../utils/functions';
import notify from '../../../utils/notify';
import FinancialSummary from '../../lists/financialSummary/FinancialSummary.vue';
import ProductsList from '../../lists/products/ProductsList.vue';
import CarregamentosForm from '../../menu/nova-cotacao-seguradora/components/carregamentosForm';
import ModalHistoricoMensageria from '../../modais/ModalHistoricoMensageria.vue';
import ModalSelectVehicleModel from '../../modais/ModalSelectVehicleModel.vue';
import { ERRORS_CODES } from '../../../constants/errors.codes.constant.js';
import EndorsementRefundScenarioAlert from './components/EndorsementRefundScenarioAlert.vue';
import ImpactedInstallmentsList from './components/ImpactedInstallmentsList.vue';
import RefundCompensationSummary from './components/RefundCompensationSummary.vue';
import RefundPayoutForm from './components/RefundPayoutForm.vue';
import {
  formatImpactedInstallments,
  getEmptyRefundCompensationData,
  getRefundCompensationScenario,
  hasImpactedInstallments,
  hasRefundPayoutData,
  isCancellationOperationType,
  normalizeRefundCompensationData,
  shouldShowRefundPayoutSection,
} from './utils/refundCompensation';
import { POLICY_CREATION_TYPE } from '@/constants/tipo.apolice';

export default {
  name: 'EndorsementQuotation',
  props: ['idEmpresaProps', 'isLanding'],
  computed: {
    isAlreadyTransmitted() {
      return functions.isAlreadyTransmitted(this.quotation.status_id);
    },
    paymentText() {
      if (
        !this.quotation ||
        !this.quotation.payment ||
        !this.quotation.payment.payment_method_id
      ) {
        return '';
      }

      const id = this.quotation.payment.payment_method_id;
      for (const key in PAYMENT_METHODS) {
        if (PAYMENT_METHODS[key].id === id) {
          return PAYMENT_METHODS[key].name;
        }
      }
      return '';
    },
    installmentsText() {
      const interestText =
        this.quotation.endorsement.prize.interest > 0 ? 'Com' : 'Sem';
      return `${
        this.quotation.endorsement.prize.installments
      }x ${functions.formataReal(
        this.quotation.endorsement.prize.monthlyPrize,
      )} - ${interestText} juros`;
    },
    dueDateText() {
      if (
        !this.quotation ||
        !this.quotation.payment ||
        !this.quotation.payment.due_day
      ) {
        return '';
      }
      return this.quotation.payment.due_day;
    },
    hasPaidCheckout() {
      const payment = this.quotation.payment;
      if (!payment || !payment.checkouts || !payment.checkouts.length) {
        return false;
      }
      const res = payment.checkouts.some((checkout) =>
        ['paid', 'waiting_payment'].includes(checkout.status),
      );
      return res;
    },
    policyStartCoverageDate() {
      if (this.quotation && this.quotation.end_of_validity) {
        const endDate = new Date(this.quotation.end_of_validity);
        endDate.setFullYear(endDate.getFullYear() - 1);
        return endDate.toISOString().split('T')[0];
      }
      return null;
    },
    showDueDay() {
      return (
        (!this.fieldsWithValidation.payment.paymentMethodId ||
          this.fieldsWithValidation.payment.paymentMethodId !==
            PAYMENT_METHODS.CREDIT_CARD.id) &&
        this.fieldsWithValidation.payment.installments &&
        (this.fieldsWithValidation.payment.installments.id > 1 ||
          this.fieldsWithValidation.payment.installments > 1)
      );
    },
    showPlate() {
      return !this.isBrandNew;
    },
    requiredStartVigencyDate() {
      return {
        invalid: !this.fieldsWithValidation.endorsement.startDate,
        message: 'O campo inicio da vigencia é obrigatório',
      };
    },
    isEdition() {
      return this.id !== null;
    },
    isPerson() {
      return (
        this.fieldsWithValidation.cpfcnpj.length <=
        this.DOCUMENT_LENGTH_WITH_MASK.CPF
      );
    },
    isRenovationByCNSeg() {
      return (
        this.fieldsWithValidation.insuranceCompanyCode &&
        this.insuranceCompanies.find(
          (company) =>
            company.id === this.fieldsWithValidation.insuranceCompanyCode,
        ) &&
        ![CONGENERS.NOT_RENEWAL.id, CONGENERS.OTHER.id].includes(
          this.fieldsWithValidation.insuranceCompanyCode,
        )
      );
    },
    plateApiFipeOptions() {
      if (!this.vehicleResult) {
        return [];
      }
      return this.vehicleResult.fipe_data;
    },
    hasZeroKmError() {
      return (
        this.fieldsWithValidation.fipeResult &&
        this.fieldsWithValidation.fipeResult.amount === 'R$ 0,00'
      );
    },
    hasCepApiReturnedInsured() {
      return !!this.fieldsWithValidation.address.cepApiResult;
    },
    exitDateTooltipText() {
      if (!this.zeroKMRule || !this.zeroKMRule.tooltipText) {
        return null;
      }
      return this.zeroKMRule.tooltipText;
    },
    hasWritePermission() {
      return this.$can('Escrita Endosso', 'Cotações');
    },
    hasReadPermission() {
      return (
        this.$can('Leitura', 'Cotações') ||
        this.$can('Leitura Carteira Completa', 'Cotações')
      );
    },
    isCancellationEndorsement() {
      return isCancellationOperationType(
        this.fieldsWithValidation &&
          this.fieldsWithValidation.endorsement &&
          this.fieldsWithValidation.endorsement.method,
      );
    },
    isCreditCardOriginalPayment() {
      const paymentMethod =
        this.originalPolicy && this.originalPolicy.paymentMethod;

      return Boolean(
        (this.originalPolicy &&
          this.originalPolicy.paymentTypeId ===
            this.PAYMENT_METHODS.CREDIT_CARD.id) ||
          (paymentMethod &&
            paymentMethod.toLowerCase() ===
              this.PAYMENT_METHODS.CREDIT_CARD.name.toLowerCase()),
      );
    },
    shouldShowRefundPayoutDisclaimer() {
      return (
        this.originalPolicy &&
        this.originalPolicy.paymentTypeId ===
          this.PAYMENT_METHODS.CREDIT_CARD.id
      );
    },
    shouldShowRefundSection() {
      return (
        this.step === 1 &&
        this.quotation &&
        this.quotation.endorsement &&
        this.quotation.endorsement.prize &&
        this.quotation.endorsement.prize.prize < 0
      );
    },
    shouldFetchRefundCompensation() {
      return this.shouldShowRefundSection && !this.isCancellationEndorsement;
    },
    shouldShowRefundCompensation() {
      return (
        this.shouldFetchRefundCompensation &&
        (this.isLoadingRefundCompensation ||
          Boolean(this.refundCompensationError) ||
          hasImpactedInstallments(this.refundCompensationData))
      );
    },
    refundCompensationData() {
      return normalizeRefundCompensationData(
        this.negativeEndorsementInstallments,
      );
    },
    refundCompensationScenario() {
      return getRefundCompensationScenario(this.refundCompensationData);
    },
    shouldShowImpactedInstallments() {
      return hasImpactedInstallments(this.refundCompensationData);
    },
    shouldShowRefundPayoutForm() {
      return this.shouldShowRefundSection;
    },
    formattedImpactedInstallments() {
      return formatImpactedInstallments(this.refundCompensationData);
    },
    isRefundCompensationReady() {
      if (!this.shouldShowRefundSection) {
        return true;
      }

      if (this.isCancellationEndorsement) {
        return true;
      }

      return Boolean(
        !this.isLoadingRefundCompensation &&
          !this.refundCompensationError &&
          this.refundCompensationScenario,
      );
    },
    originalStartOfValidity() {
      return moment(this.originalQuotation.start_of_validity)
        .startOf('day')
        .toDate();
    },
    originalEndOfValidity() {
      return moment(this.originalQuotation.end_of_validity)
        .startOf('day')
        .toDate();
    },
  },
  watch: {
    fieldsWithValidation: {
      handler() {
        if (!this.quoatiotionGenerated) return;
        this.validateForm();
      },
      deep: true,
    },
    isRenovationByCNSeg(newValue) {
      if (newValue === false) {
        this.fieldsWithValidation.bonus = 0;
      }
    },
    'fieldsWithValidation.vehicleIsOutOfDealership': {
      handler(newVal) {
        if (!newVal) {
          this.fieldsWithValidation.dealershipExitDate = null;
        }
      },
    },
    'fieldsWithValidation.cpfcnpj'() {
      if (
        this.fieldsWithValidation.cpfcnpj.length ===
        this.DOCUMENT_LENGTH_WITH_MASK.CNPJ
      ) {
        this.fieldsWithValidation.socialName = false;
        this.fieldsWithValidation.civilName = '';
        this.insuredIsMainDriver = false;
        return;
      }

      if (!this.fieldsWithValidation.cpfcnpj) {
        this.clearInsuredData();
      }

      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverCpfCnpj =
          this.fieldsWithValidation.cpfcnpj;
      }
    },
    'fieldsWithValidation.driverCpfCnpj'(newVal) {
      if (!newVal) {
        this.clearDriverData();
        return;
      }
      if (
        this.fieldsWithValidation.cpfcnpj.length ===
          this.DOCUMENT_LENGTH_WITH_MASK.CPF &&
        this.fieldsWithValidation.cpfcnpj ===
          this.fieldsWithValidation.driverCpfCnpj
      ) {
        this.insuredIsMainDriver = true;
      }
    },
    'fieldsWithValidation.name'() {
      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverName = this.fieldsWithValidation.name;
      }
    },
    'fieldsWithValidation.socialName'() {
      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverSocialName =
          this.fieldsWithValidation.socialName;
        this.fieldsWithValidation.civilName = '';
      }
    },
    'fieldsWithValidation.civilName'() {
      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverCivilName =
          this.fieldsWithValidation.civilName;
      }
    },
    'fieldsWithValidation.birthDate'() {
      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverBirthdate =
          this.fieldsWithValidation.birthDate;
      }
    },
    'fieldsWithValidation.gender'() {
      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverGender =
          this.fieldsWithValidation.gender;
      }
    },
    discount() {
      this.recalculateProductValues = true;
    },
    insuredIsMainDriver() {
      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverCpfCnpj =
          this.fieldsWithValidation.cpfcnpj;
        this.fieldsWithValidation.driverName = this.fieldsWithValidation.name;
        this.fieldsWithValidation.driverSocialName =
          this.fieldsWithValidation.socialName;
        this.fieldsWithValidation.driverCivilName =
          this.fieldsWithValidation.civilName;
        this.fieldsWithValidation.driverGender =
          this.fieldsWithValidation.gender;
        this.fieldsWithValidation.driverBirthdate =
          this.fieldsWithValidation.birthDate;
      } else {
        this.fieldsWithValidation.driverCpfCnpj = '';
        this.fieldsWithValidation.driverName = '';
        this.fieldsWithValidation.driverSocialName = false;
        this.fieldsWithValidation.driverCivilName = '';
        this.fieldsWithValidation.driverBirthdate = '';
        this.fieldsWithValidation.driverGender = '';
      }
    },
    async 'fieldsWithValidation.selectedPayment'() {
      await this.setInstallmentsSelected();
    },
    async 'fieldsWithValidation.endorsement.method'() {
      if (!this.$refs.startValidityPicker) {
        return;
      }
      this.$refs.startValidityPicker.fp.clear();
      this.clearVehicleData();
      await this.getQuotation();
      this.getStartDateConfigs();
    },
    async 'fieldsWithValidation.endorsement.startDate'() {
      this.getStartDateConfigs();
    },
  },
  data() {
    const dataAtual = new Date();
    const dataFutura30Dias = new Date();
    dataFutura30Dias.setDate(dataAtual.getDate() + 30);
    return {
      ERRORS_CODES,
      PERMISSIONS_ACTIONS,
      PERMISSIONS_NAMES,
      historyAlterationsActive: false,
      historyMessagingActive: false,
      endorsementFormUrl: process.env.VUE_APP_URL_FORM_ENDORSEMENT,
      outOfDealershipOptions: [
        { value: true, label: 'Sim' },
        { value: false, label: 'Não' },
      ],
      step: null,
      blockSelectOperation: false,
      paymentMethods: [],
      dataFutura30Dias,
      isNewFromPolicyIdentifier: false,
      endorsementJustCreatedInSession: false,

      LIST_ESTADO_CIVIL,
      PAYMENT_METHODS,
      POLICY_STATUSES,
      POLICY_TYPES: TIPOS_APOLICES,
      LIST_SEXO,
      STATUS_PROPOSTA,
      DOCUMENT_MASK: DOCUMENT_MASK,
      DOCUMENT_LENGTH_WITH_MASK: DOCUMENT_LENGTH_WITH_MASK,

      formatEmitterNumber: functions.formatEmitterNumber,
      formatDateBr: dateConversion.convertISOToDate,
      formatDateNoTime: dateConversion.converteISOToDate,

      fieldsWithValidation: {
        brokerId: null,
        insuranceCompanyCode: null,
        startOfValidity: '',
        endOfValidity: '',
        bonus: null,
        ci: null,
        previousCoverageEndDate: '',
        isSameVehicle: null,
        cpfcnpj: '',
        name: '',
        ie: null,
        civilName: '',
        socialName: false,
        birthDate: null,
        gender: null,
        maritalStatus: null,
        cellphone: '',
        email: null,
        ppeDescription: null,
        endorsement: {
          method: null,
          startDate: null,
        },
        address: {
          zipCode: '',
          street: null,
          number: null,
          complement: null,
          neighborhood: null,
          city: null,
          state: null,
          cepApiResult: false,
        },
        driverBirthdate: null,
        driverGender: null,
        driverName: '',
        driverCivilName: '',
        driverCpfCnpj: '',
        driverEmail: null,
        driverSocialName: false,
        overnightAddress: {
          zipCode: '',
          street: null,
          number: null,
          complement: null,
          neighborhood: null,
          city: null,
          state: null,
          cepApiResult: false,
        },
        vehiclePlate: '',
        vehicleChassis: '',
        vehicleBrandId: null,
        vehicleModelId: null,
        vehicleYearModel: null,
        fipeResult: null,
        increasesAnswers: {},
        vehicleInvoiceNumber: null,
        vehicleInvoiceDate: '',
        vehicleIsOutOfDealership: null,
        dealershipExitDate: null,
        selectedPayment: null,
        payment: {
          paymentMethodId: null,
          installments: null,
          dueDay: null,
          automaticDebit: {
            bank: null,
            agency: null,
            account: null,
            accountDigit: null,
          },
        },
        selectedProducts: [],
        refundData: {
          bankId: null,
          agency: null,
          account: null,
          accountDigit: null,
          pixKey: null,
          holderName: null,
          holderDocument: null,
        },
      },
      isValidRcfValue: true,
      endorsementStartDateConfig: {},
      id: null,
      proposalId: null,
      deal: false,
      key: null,
      showQuotationDeniedModal: false,
      proposalResponseReason: null,
      policyTypes: TIPOS_APOLICES,
      debounceBankSearch: debounce(this.searchBank, 500),
      fixedButton: this.$route.query.fixedesabilitaAlterarMarcaButton,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      showPanel: this.$route.query.showPanel,
      hideLogo: this.$route.query.hideLogo,
      isInterno: false,
      logo: '',
      brokers: [],
      coverages: [],
      insuranceCompanies: [],
      bonuses: [
        {
          id: 1,
          label: 'Não',
        },
        {
          id: 2,
          label: 'Sim, renovação da BP Seguradora',
        },
        {
          id: 3,
          label: 'Sim, renovação de outra seguradora afiliada à CNSEG',
        },
        {
          id: 4,
          label: 'Sim, renovação de outra segurado não afiliada à CNSEG',
        },
      ],
      isRenovation: null,
      previousPolicyNumber: null,
      bonusesLevel: [
        {
          id: 0,
          label: 0,
        },
        {
          id: 1,
          label: 1,
        },
        {
          id: 2,
          label: 2,
        },
        {
          id: 3,
          label: 3,
        },
        {
          id: 4,
          label: 4,
        },
        {
          id: 5,
          label: 5,
        },
        {
          id: 6,
          label: 6,
        },
        {
          id: 7,
          label: 7,
        },
        {
          id: 8,
          label: 8,
        },
        {
          id: 9,
          label: 9,
        },
        {
          id: 10,
          label: 10,
        },
      ],
      isPoliticallyExposed: false,
      insuredIsMainDriver: false,
      estados: [],
      cidades: [],
      isBrandNew: false,
      vehicleFound: true,
      searchingPlate: false,
      searchingChassi: false,
      vehicleIsOutOfDaelership: true,
      vehicleTypeId: {
        id: 1,
        label: 'Carro',
      },
      vehicleFuelId: null,
      selectedCoverage: null,
      vehicleBrand: null,
      vehicleModel: null,
      vehicleYearFactory: null,
      vehicleFipeCode: null,
      vehicleColor: null,
      vehiclePorts: null,
      vehicleEngineNumber: null,
      vehicleRenavam: null,
      vehicleCylinderCapacity: null,
      vehicleFuel: null,
      vehiclePassengerQuantity: null,
      modalInfoDataSaidaNf: false,
      vehicleTypes: [],
      vehicleBrands: [],
      vehicleModels: [],
      vehicleYearsModel: [],
      increases: [],
      zipCodeIncreases: null,
      increasesOldFormat: [],
      vehicleResult: null,
      fuelCode: {
        G: 1,
        A: 2,
        D: 3,
        E: 4,
        F: 5,
        H: 6,
      },
      selectedFipeModel: null,
      quotation: null,
      originalQuotation: null,
      prize: null,
      quoatiotionGenerated: false,
      products: [],
      selectedProducts: [],
      productsList: [],
      form: {
        carregamentos: {
          'Despesa ADM': { porcentagem: 0 },
          'Margem de Lucro': { porcentagem: 0 },
          Corretagem: { porcentagem: 0 },
          Estipulante: { porcentagem: 0 },
        },
        desconto: 0,
      },
      recalculateProductValues: false,
      discount: 0,
      brokerAccountConfigs: null,
      listAllowedStates: [],
      maxRcfCoverageValue: null,
      cepApiResult: false,
      resetModalVehicleModel: false,
      showSelectPlateModal: false,
      hasCepApiReturnedOvernightStreet: true,
      hasCepApiReturnedOvernightNeighborhood: true,
      hasCepApiReturnedOvernightState: true,
      hasCepApiReturnedOvernightCity: true,
      hasCepApiReturnedStreet: true,
      hasCepApiReturnedNeighborhood: true,
      hasCepApiReturnedState: true,
      hasCepApiReturnedCity: true,
      brokerAccountBalanceInsufficient: false,
      brokerAccountBalanceUsed: false,
      dueDays: [],
      brokerId: null,
      policyDocumentBonus: null,
      invoiceDocument: null,
      installments: [],
      overnightCepApiResult: false,
      vehicleGroupId: null,
      isSameVehicleOptions: [
        { value: true, label: 'Sim' },
        { value: false, label: 'Não' },
      ],
      refundBankOptions: [],
      banks: ['Itaú', 'Caixa Econômica Federal'],
      disablePlate: false,
      disableChassis: false,
      disableBrand: false,
      disableModel: false,
      disableYearModel: false,
      files: new FormData(),
      operationTypes: [],
      zeroKMRule: null,
      originalPolicy: null,
      negativeEndorsementInstallments: getEmptyRefundCompensationData(),
      isLoadingRefundCompensation: false,
      refundCompensationError: null,
      previousValues: {},
    };
  },
  methods: {
    closeMessagingModal() {
      this.historyMessagingActive = false;
    },
    clearDriverData() {
      this.fieldsWithValidation.driverName = '';
      this.fieldsWithValidation.driverSocialName = false;
      this.fieldsWithValidation.driverCivilName = '';
      this.fieldsWithValidation.driverBirthdate = '';
      this.fieldsWithValidation.driverGender = '';
      this.fieldsWithValidation.driverEmail = '';
    },
    clearInsuredData() {
      this.fieldsWithValidation.name = '';
      this.fieldsWithValidation.ie = null;
      this.fieldsWithValidation.socialName = false;
      this.fieldsWithValidation.civilName = '';
      this.fieldsWithValidation.birthDate = null;
      this.fieldsWithValidation.gender = null;
      this.fieldsWithValidation.maritalStatus = null;
      this.fieldsWithValidation.cellphone = '';
      this.fieldsWithValidation.email = null;
      this.fieldsWithValidation.ppeDescription = null;
      this.isPoliticallyExposed = false;
    },
    resetRefundCompensationData() {
      this.negativeEndorsementInstallments = getEmptyRefundCompensationData();
      this.isLoadingRefundCompensation = false;
      this.refundCompensationError = null;
    },
    getRefundPayload() {
      if (!this.shouldShowRefundPayoutForm) {
        return null;
      }

      const refundData = this.fieldsWithValidation.refundData;

      if (!hasRefundPayoutData(refundData)) {
        return null;
      }

      return refundData;
    },
    async refreshRefundCompensation() {
      if (
        !this.shouldFetchRefundCompensation ||
        !this.quotation ||
        !this.quotation.id
      ) {
        this.resetRefundCompensationData();
        return;
      }

      await this.getNegativeEndorsementInstallments();
    },
    async getNegativeEndorsementInstallments() {
      this.isLoadingRefundCompensation = true;
      this.refundCompensationError = null;

      try {
        const response = await autoApi.getNegativeEndorsementInstallments(
          this.quotation.id,
        );

        this.negativeEndorsementInstallments =
          normalizeRefundCompensationData(response);
      } catch (error) {
        console.error('ERRO COMPENSACAO RESTITUICAO', error);
        this.negativeEndorsementInstallments = getEmptyRefundCompensationData();
        this.refundCompensationError =
          'Nao foi possivel buscar as parcelas impactadas e o saldo residual da restituicao.';
      } finally {
        this.isLoadingRefundCompensation = false;
      }
    },

    openPdf(link) {
      window.open(link, '_blank');
    },

    getValidationRules(fieldKey, rules, oldValue = '') {
      let rulesToApply = this.isFieldEditable(fieldKey) ? rules : '';
      const addChangeRequiredRule = this.fieldHasToBeChanged(fieldKey);

      if (addChangeRequiredRule) {
        rulesToApply =
          typeof rulesToApply === 'string'
            ? `${rulesToApply}|change_required:${oldValue}`
            : { ...rulesToApply, change_required: oldValue };
      }
      return rulesToApply;
    },

    getManualVehicleValidationRules(fieldKey, rules, oldValue = '') {
      let rulesToApply = this.isFieldEditable(fieldKey) ? rules : '';
      const addChangeRequiredRule = this.fieldHasToBeChanged(fieldKey);

      if (addChangeRequiredRule) {
        rulesToApply =
          typeof rulesToApply === 'string'
            ? `${rulesToApply}|change_required_manual_vehicle:${oldValue}`
            : { ...rulesToApply, change_required_manual_vehicle: oldValue };
      }
      return rulesToApply;
    },

    getManualVehicleYearValidationRules(fieldKey, rules, oldValue = '') {
      let rulesToApply = this.isFieldEditable(fieldKey) ? rules : '';
      const addChangeRequiredRule = this.fieldHasToBeChanged(fieldKey);

      if (addChangeRequiredRule) {
        rulesToApply =
          typeof rulesToApply === 'string'
            ? `${rulesToApply}|change_required_manual_vehicle_year:${oldValue}`
            : {
                ...rulesToApply,
                change_required_manual_vehicle_year: oldValue,
              };
      }
      return rulesToApply;
    },

    getFipeValueValidationRules(fieldKey, rules, oldValue = '') {
      let rulesToApply = this.isFieldEditable(fieldKey) ? rules : '';
      const addChangeRequiredRule = this.fieldHasToBeChanged(fieldKey);
      const formattedOldValue = oldValue
        .replace('R$ ', '')
        .replace('.', '')
        .replace(',', '.');
      if (addChangeRequiredRule) {
        rulesToApply =
          typeof rulesToApply === 'string'
            ? `${rulesToApply}|change_required_fipe_value:${formattedOldValue}`
            : {
                ...rulesToApply,
                change_required_fipe_value: formattedOldValue,
              };
      }
      return rulesToApply;
    },

    getIncreasesValidationRules(fieldKey, rules) {
      let rulesToApply = this.isFieldEditable(fieldKey) ? rules : '';
      const addChangeRequiredRule = this.fieldHasToBeChanged(fieldKey);
      if (addChangeRequiredRule) {
        rulesToApply = `${rulesToApply}|change_required_increases`;
      }
      return rulesToApply;
    },

    getProductsValidationRules(fieldKey, rules) {
      let rulesToApply = this.isFieldEditable(fieldKey) ? rules : '';
      const addChangeRequiredRule = this.fieldHasToBeChanged(fieldKey);
      if (addChangeRequiredRule) {
        rulesToApply = {
          ...rulesToApply,
          change_required_products: true,
        };
      }
      return rulesToApply;
    },

    fieldHasToBeChanged(fieldKey) {
      if (this.isQuotationBlocked()) {
        return false;
      }
      if (
        !this.fieldsWithValidation.endorsement.method ||
        !this.fieldsWithValidation.endorsement.method.mandatoryChangeFields
      ) {
        return false;
      }
      return this.fieldsWithValidation.endorsement.method.mandatoryChangeFields.includes(
        fieldKey,
      );
    },

    addDealershipExitDateValidation() {
      Validator.extend('after_invoice_date', {
        getMessage: (field) =>
          `${field} não deve ser anterior a data de emissão da nota fiscal.`,
        validate: (value) => {
          if (!this.fieldsWithValidation.vehicleInvoiceDate) {
            return false;
          }
          let [day, month, year] = value.split('/');
          const dealershipExitDate = new Date(year, month - 1, day, 0, 0, 0);
          [day, month, year] =
            this.fieldsWithValidation.vehicleInvoiceDate.split('/');
          const invoiceDate = new Date(year, month - 1, day, 0, 0, 0);

          return dealershipExitDate >= invoiceDate;
        },
      });
    },
    addMin30DaysValidation() {
      Validator.extend('min_30days', {
        getMessage: () => `Não deve ser inferior a 30 dias.`,
        validate: (value) => {
          if (this.isQuotationBlocked()) {
            return true;
          }
          let [day, month, year] = value.split('/');
          let dateNf = new Date(year, month - 1, day, 0, 0, 0);
          let today = new Date();
          today.setHours(0, 0, 0, 0);

          let minDate = new Date(today);
          minDate.setDate(minDate.getDate() - 30);

          return dateNf >= minDate;
        },
      });
    },
    getInvoiceDateRules() {
      return this.isFieldEditable('vehicle-invoice-date')
        ? 'date_format:dd/MM/yyyy|less_than_today|min_30days'
        : '';
    },
    redirectListQuotationPage() {
      this.$router.push({ name: 'Cotações' });
    },
    getZeroKMRule() {
      lifeApi
        .getAll('prior-inspections')
        .then((response) => {
          const zeroKMRule = response.data.find((item) => item.name === '0KM');
          if (zeroKMRule) {
            this.zeroKMRule = zeroKMRule.registrations;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    checkAccessPermission() {
      if (!this.hasWritePermission && !this.hasReadPermission) {
        this.$router.push({ name: 'pageError404' });
        return false;
      }
      return true;
    },
    async setInstallmentsSelected() {
      if (!this.fieldsWithValidation.selectedPayment) return;
      this.fieldsWithValidation.payment.paymentMethodId =
        this.fieldsWithValidation.selectedPayment.paymentMethodId;
      this.installments = [];

      paymentMethodConfigApi
        .getInstallmentByPolicy(
          this.fieldsWithValidation.selectedPayment.paymentMethodId,
          this.quotation.id,
        )
        .then((response) => {
          this.$vs.loading.close();
          this.installments = response;
          this.fieldsWithValidation.payment.installments =
            this.installments.find((installment) => {
              return (
                this.fieldsWithValidation.payment.installments.id ===
                installment.id
              );
            });
        });
    },
    moveToEndorsementDetails() {
      const selectedOperation = this.operationTypes.find(
        (op) => op.id === this.quotation.endorsement.operationTypeId,
      );

      if (selectedOperation) {
        this.fieldsWithValidation.endorsement.method = selectedOperation;
        this.blockSelectOperation = true;
      }

      this.step = 0;
      if (!this.isQuotationBlocked() && this.hasWritePermission) {
        this.clearRefundData();
      }
    },
    async changePaymentMethod() {
      this.$nextTick(() => {
        this.$validator.reset('Nº de Parcelas');
        this.$validator.reset('Dia do Vencimento');
        this.fieldsWithValidation.payment.installments = {};
        this.fieldsWithValidation.payment.dueDay = null;
      });
      await this.recalculateEndorsement();
    },
    isQuotationBlocked() {
      if (this.isNewFromPolicyIdentifier) {
        return false;
      }

      return (
        this.quotation &&
        ![STATUS_PROPOSTA.EM_TRANSMISSAO.id].includes(
          this.quotation.status_id,
        ) &&
        this.quotation.creationType === POLICY_CREATION_TYPE.ENDORSEMENT.value
      );
    },
    searchBank(searchTerm) {
      bankApi
        .getBanksWithSearch(searchTerm)
        .then((response) => {
          this.refundBankOptions = response.map((bank) => {
            return {
              id: bank.id,
              label: bank.longName,
            };
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    isVehicleEditable() {
      return (
        this.isFieldEditable('vehicle-brand') &&
        this.isFieldEditable('vehicle-model') &&
        this.isFieldEditable('vehicle-model-year')
      );
    },
    isInsuredMainDriverFieldEditable(insuredFieldTestId, driverFieldTestId) {
      return this.insuredIsMainDriver
        ? this.isFieldEditable(insuredFieldTestId) &&
            this.isFieldEditable(driverFieldTestId)
        : this.isFieldEditable(insuredFieldTestId);
    },
    isFieldEditable(fieldTestId) {
      const hasEndorsementMethod =
        this.fieldsWithValidation &&
        this.fieldsWithValidation.endorsement &&
        this.fieldsWithValidation.endorsement.method;

      if (
        !hasEndorsementMethod ||
        this.isQuotationBlocked() ||
        !this.hasWritePermission
      ) {
        return false;
      }
      return (
        this.fieldsWithValidation.endorsement.method.editableFields.indexOf(
          fieldTestId,
        ) !== -1
      );
    },
    getEndormentOperationTypes() {
      endorsementApi
        .getOperationTypes()
        .then((res) => {
          this.operationTypes = res;
        })
        .catch(() => {
          this.operationTypes = [];
        });
    },
    getStartDateConfigs() {
      this.endorsementStartDateConfig = {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
        ...this.getDateMaxRange(),
      };
    },
    isValidityYetToStart() {
      return this.originalStartOfValidity > moment().startOf('day').toDate();
    },
    getDateMaxRange() {
      if (this.isQuotationBlocked()) {
        return {
          maxDate: null,
          minDate: null,
        };
      }
      if (!this.fieldsWithValidation.endorsement.method) {
        const defaultLimit = new Date();
        defaultLimit.setDate(defaultLimit.getDate() + 30);
        return {
          minDate: 'today',
          maxDate: defaultLimit,
        };
      }
      const minDate =
        (this.fieldsWithValidation.endorsement.method &&
          this.fieldsWithValidation.endorsement.method
            .acceptsRetroactiveValidity) ||
        this.isValidityYetToStart()
          ? this.originalStartOfValidity
          : 'today';
      const additionalDaysAllowedForStartDate =
        this.fieldsWithValidation.endorsement.method
          .additionalDaysAllowedForStartDate || 0;
      let maxDate = new Date();
      maxDate.setDate(maxDate.getDate() + additionalDaysAllowedForStartDate);
      if (maxDate < this.originalStartOfValidity) {
        maxDate = this.originalStartOfValidity;
      }
      if (maxDate > this.originalEndOfValidity) {
        maxDate = this.originalEndOfValidity;
      }
      return {
        maxDate: maxDate,
        minDate: minDate,
      };
    },
    chooseFiles(inputId) {
      document.getElementById(inputId).click();
    },
    validateForm() {
      this.$nextTick(() => {
        this.$refs.newQuotationForm.validate();
      });
    },
    getVehicleYearModelLabel(vehicleYearModel) {
      return `${vehicleYearModel.year_model} ${vehicleYearModel.fuel}`;
    },
    createDynamicValidations() {
      Validator.extend('estado_pernoite', {
        getMessage: () =>
          `Pernoite deve ser em ${this.listAllowedStates.join(', ')}.`,
        validate: (value) => {
          return this.listAllowedStates.includes(value.toUpperCase());
        },
      });
    },
    createValidations() {
      Validator.extend('cpf_cnpj_min', {
        getMessage: (field) =>
          `O campo ${field} deve possuir ${this.DOCUMENT_LENGTH_WITH_MASK.CPF} ou ${this.DOCUMENT_LENGTH_WITH_MASK.CNPJ} caracteres.`,
        validate: (value) => {
          return (
            value.length === this.DOCUMENT_LENGTH_WITH_MASK.CPF ||
            value.length === this.DOCUMENT_LENGTH_WITH_MASK.CNPJ
          );
        },
      });
      Validator.extend('min_age', {
        getMessage: () => `Você deve ter pelo menos 18 anos.`,
        validate: (value) => {
          let [day, month, year] = value.split('/');
          let birthDate = new Date(year, month - 1, day, 0, 0, 0);
          let today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          let m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          return age >= 18;
        },
      });
      Validator.extend('max_age', {
        getMessage: () => `Você deve ter pelo menos 100 anos.`,
        validate: (value) => {
          let [day, month, year] = value.split('/');
          let birthDate = new Date(year, month - 1, day, 0, 0, 0);
          let today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          let m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          return age <= 100;
        },
      });
      Validator.extend('less_than_today', {
        getMessage: () => `A data deve ser menor ou igual a hoje.`,
        validate: (value) => {
          let [day, month, year] = value.split('/');
          let dateNf = new Date(year, month - 1, day, 0, 0, 0);
          let today = new Date();
          return dateNf <= today;
        },
      });
      Validator.extend('min_30days', {
        getMessage: () => `Não deve ser inferior a 30 dias.`,
        validate: (value) => {
          let [day, month, year] = value.split('/');
          let dateNf = new Date(year, month - 1, day, 0, 0, 0);
          let today = new Date();
          today.setHours(0, 0, 0, 0);

          let minDate = new Date(today);
          minDate.setDate(minDate.getDate() - 30);

          return dateNf >= minDate;
        },
      });
      Validator.extend('cpf_cnpj', {
        getMessage: (field) =>
          `O campo ${field} deve ser um CPF ou CNPJ válido.`,
        validate: (value) => {
          return cpfcnpj.valida_cpf_cnpj(value);
        },
      });
      Validator.extend('nome', {
        getMessage: (field) =>
          `O campo ${field} deve ser um ${
            field === 'CEP' ? field : 'Nome'
          } válido.`,
        validate: (value) => {
          return functions.nameValidate(value, this.isPerson);
        },
      });
      Validator.extend('is-person-name', {
        getMessage: (field) =>
          `O campo ${field} deve ser um ${
            field === 'CEP' ? field : 'Nome'
          } válido.`,
        validate: (value) => {
          return functions.nameValidate(value, true);
        },
      });
      Validator.extend('dddValidos', {
        getMessage: (field) => `O DDD ${field} não é valido,`,
        validate: (value) => {
          const ddd = value.substring(1, 3);
          const isValidDDD = DDD_BRASIL.includes(+ddd);
          return isValidDDD;
        },
      });
      Validator.extend('br_phone', {
        getMessage: (field) =>
          `O campo ${field} deve ser um número de celular válido.`,
        validate: (value) => {
          const regex = /^(\+55)?\s?\(?\d{2}\)?\s?\d{5}-?\d{4}$/;
          return regex.test(value);
        },
      });
      Validator.extend('change_required', {
        getMessage: (field) => `O campo ${field} deve ser alterado.`,
        validate: (value, [previousValue]) => {
          return (
            // eslint-disable-next-line no-useless-escape
            String(value).replace(/[.,\-\/()]/g, '') !==
            // eslint-disable-next-line no-useless-escape
            String(previousValue).replace(/[.,\-\/()]/g, '')
          );
        },
        params: ['previousValue'],
        hasTarget: true,
      });
      Validator.extend('change_required_manual_vehicle', {
        getMessage: (field) => `O campo ${field} deve ser alterado.`,
        validate: (value, [previousValue]) => {
          if (!value) {
            return true;
          }
          return String(value.id) !== String(previousValue);
        },
        params: ['previousValue'],
        hasTarget: true,
      });
      Validator.extend('change_required_manual_vehicle_year', {
        getMessage: (field) => `O campo ${field} deve ser alterado.`,
        validate: (value, [previousValue]) => {
          if (!value) {
            return true;
          }
          return String(value.year) !== String(previousValue);
        },
        params: ['previousValue'],
        hasTarget: true,
      });
      Validator.extend('change_required_fipe_value', {
        getMessage: (field) => `O campo ${field} deve ser alterado.`,
        validate: (value, [oldValue]) => {
          const formattedValue = value
            .replace('R$ ', '')
            .replace('.', '')
            .replace(',', '.');
          return formattedValue !== oldValue;
        },
        params: ['oldValue'],
        hasTarget: true,
      });
      Validator.extend('change_required_increases', {
        getMessage: () => `O Questionário de Avaliação de Risco deve alterado.`,
        validate: () => {
          return this.originalQuotation.increases_answers.some((increase) => {
            return (
              this.fieldsWithValidation.increasesAnswers[increase.id].id !==
              increase.answers
            );
          });
        },
        hasTarget: true,
      });
      Validator.extend('change_required_products', {
        getMessage: () => `Os produtos devem alterados.`,
        validate: () => {
          return this.originalQuotation.coverage_contracted.some(
            (originalCoverage) => {
              const newCoverage =
                this.fieldsWithValidation.selectedProducts.find(
                  (product) => product.id === originalCoverage.id,
                );
              return (
                !newCoverage ||
                originalCoverage.quantity !== newCoverage.quantity
              );
            },
          );
        },
        hasTarget: true,
      });
    },
    updateSelectedSliderProduct(productChanged) {
      this.fieldsWithValidation.selectedProducts =
        this.fieldsWithValidation.selectedProducts.map((product) =>
          product.id === productChanged.id
            ? { ...product, quantity: productChanged.quantity }
            : product,
        );
      const alreadyInSelected = this.fieldsWithValidation.selectedProducts.find(
        (product) => product.id === productChanged.id,
      );
      if (!alreadyInSelected) {
        this.fieldsWithValidation.selectedProducts.push({
          id: productChanged.id,
          quantity: productChanged.quantity,
        });
      }
    },
    updateSelectedSelectProduct(productChanged) {
      const productChangedGroupingIds = this.products
        .filter((product) => product.grouping === productChanged.grouping)
        .map((product) => product.id);
      this.fieldsWithValidation.selectedProducts =
        this.fieldsWithValidation.selectedProducts.map((product) =>
          productChangedGroupingIds.includes(product.id)
            ? { ...product, id: productChanged.id }
            : product,
        );
    },
    updateSelectedProducts(productChanged) {
      if (productChanged.input === 'slider') {
        this.updateSelectedSliderProduct(productChanged);
        return;
      }
      this.updateSelectedSelectProduct(productChanged);
    },
    updateIsValidRcfValue(isValidRcfValue) {
      if (this.isValidRcfValue === isValidRcfValue) return;
      this.isValidRcfValue = isValidRcfValue;
      if (!isValidRcfValue) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Soma dos RCFs não deve ultrapassar R$ ${
            this.maxRcfCoverageValue / 1000
          } mil`,
          color: 'danger',
        });
      }
    },
    clearAllVehicleData() {
      this.fieldsWithValidation.vehiclePlate = '';
      this.fieldsWithValidation.vehicleIsOutOfDealership = null;
      this.clearVehicleData();
    },
    clearVehicleData() {
      this.fieldsWithValidation.vehicleChassis = '';
      this.fieldsWithValidation.vehicleBrandId = null;
      this.fieldsWithValidation.vehicleModelId = null;
      this.fieldsWithValidation.vehicleYearModel = null;
      this.fieldsWithValidation.fipeResult = null;
      this.fieldsWithValidation.vehicleInvoiceNumber = null;
      this.fieldsWithValidation.vehicleInvoiceDate = null;
      this.vehicleIsOutOfDaelership = false;
      this.invoiceDocument = null;

      this.vehicleResult = null;
      this.selectedFipeModel = null;
      this.vehicleTypeId = {
        id: 1,
        label: 'Carro',
      };
      this.vehicleFuelId = null;
      this.vehicleBrand = null;
      this.vehicleModel = null;
      this.vehicleYearFactory = null;
      this.vehicleFipeCode = null;
      this.vehicleColor = null;
      this.vehicleEngineNumber = null;
      this.vehicleRenavam = null;
      this.vehicleCylinderCapacity = null;
      this.vehicleFuel = null;
      this.vehiclePassengerQuantity = null;

      this.coverages = [];
      this.selectedCoverage = null;
    },
    clearVehicleDataWithOutChassi() {
      this.vehicleResult = null;
      this.selectedFipeModel = null;
      this.vehicleTypeId = {
        id: 1,
        label: 'Carro',
      };
      this.fieldsWithValidation.vehicleBrandId = null;
      this.fieldsWithValidation.vehicleModelId = null;
      this.vehicleFuelId = null;
      this.fieldsWithValidation.vehicleYearModel = null;
      this.vehicleBrand = null;
      this.vehicleModel = null;
      this.vehicleYearFactory = null;
      this.vehicleFipeCode = null;
      this.vehicleColor = null;
      this.vehicleEngineNumber = null;
      this.vehicleRenavam = null;
      this.vehicleCylinderCapacity = null;
      this.vehicleFuel = null;
      this.vehiclePassengerQuantity = null;
      this.fieldsWithValidation.fipeResult = null;
      this.coverages = [];
      this.selectedCoverage = null;
      this.fieldsWithValidation.vehicleInvoiceNumber = null;
      this.fieldsWithValidation.vehicleInvoiceDate = null;
      this.vehicleIsOutOfDaelership = false;
    },
    filterOptions(options, search) {
      const filtered = options.filter((option) => {
        return (
          option.label.toLowerCase().includes(search.toLowerCase()) ||
          option.label === 'Sim, outra seguradora'
        );
      });

      return filtered;
    },
    getSelectedCongenerLabel(item) {
      const congener = this.insuranceCompanies.find((company) => {
        return company.id === item.id;
      });
      if (congener) {
        return congener.label;
      }
      return item.id === CONGENERS.NOT_RENEWAL.id
        ? CONGENERS.NOT_RENEWAL.label
        : CONGENERS.OTHER.label;
    },
    setDefaultSelectedProducts() {
      this.fieldsWithValidation.selectedProducts = this.products
        .filter(
          (product) => Boolean(product.mandatory) || product.input === 'slider',
        )
        .map((product) => {
          return {
            id: product.id,
            quantity:
              product.input === 'slider' ? Number(product.defaultLmi) : 1,
          };
        });
    },
    handleTransmissionError(error) {
      const errorStatus = error.response ? error.response.status : null;
      const customErrorMessageStatuses = [400, 409, 423, 503];
      const quotationDeniedStatus = 422;

      const customErrorMessage =
        error.response.data && error.response.data.message;
      const errorMessage =
        customErrorMessage && customErrorMessageStatuses.includes(errorStatus)
          ? customErrorMessage
          : 'Não foi possível transmitir a proposta de endosso';

      const errorCode = error.response.data && error.response.data.code;
      const invalidaCreditCardHolderError =
        errorStatus === 400 &&
        errorCode === ERRORS_CODES.INVALID_REFUND_HOLDER_DOCUMENT;

      if (errorStatus === quotationDeniedStatus) {
        this.showQuotationDeniedModal = true;
        const raw = error.response.data.message || '';
        let parsed = { text: raw };
        try {
          const p = JSON.parse(raw);
          if (p && p.text) parsed = p;
        } catch (error) {
          parsed = { text: raw };
        }

        this.proposalResponseReason = parsed.text || raw;
        return;
      }

      notify.notifyFail(this.$vs, errorMessage);

      if (invalidaCreditCardHolderError) {
        this.clearRefundData();
      }
    },
    handleCreateQuotationError(error, isTransmission) {
      this.$vs.loading.close();

      if (isTransmission) {
        this.handleTransmissionError(error);
        return;
      }

      this.brokerAccountBalanceInsufficient =
        !this.brokerAccountBalanceInsufficient;

      notify.notifyFail(
        this.$vs,
        'Não foi possível criar a cotação de endosso',
      );
    },
    createQuotation(isTransmission = false) {
      const invoiceDataMissing =
        !this.fieldsWithValidation.vehicleInvoiceDate ||
        !this.fieldsWithValidation.vehicleInvoiceNumber ||
        this.fieldsWithValidation.vehicleIsOutOfDealership == null;
      const invoiceDataMissingError = this.isBrandNew && invoiceDataMissing;
      const plateMissingError =
        !this.isBrandNew && !this.fieldsWithValidation.vehiclePlate;
      const exitDateMissingError =
        this.isBrandNew &&
        this.fieldsWithValidation.vehicleIsOutOfDealership &&
        !this.fieldsWithValidation.dealershipExitDate;
      if (
        isTransmission &&
        (invoiceDataMissingError ||
          !this.fieldsWithValidation.vehicleChassis ||
          plateMissingError ||
          exitDateMissingError)
      ) {
        notify.notifyFail(
          this.$vs,
          'Existem campos obrigatórios em branco em Dados do Veículo',
        );
        return;
      }

      if (!this.hasWritePermission) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível finalizar a cotação',
          color: 'danger',
        });
        return;
      }

      const formatedCharges = [];

      for (let carregamento of Object.keys(this.form.carregamentos)) {
        const charge = this.form.carregamentos[carregamento];
        formatedCharges.push({
          id: charge.idCarregamento,
          percentage: Number(charge.porcentagem),
        });
      }

      const payload = this.getBasePayload(isTransmission);

      const updatePayload = {
        charges: formatedCharges,
        coverage_products: [
          ...this.fieldsWithValidation.selectedProducts,
        ].filter((product) => product.quantity !== 0),
        discount: Number(
          typeof this.form.desconto === 'string'
            ? this.form.desconto
                .replace('R$ ', '')
                .replace('.', '')
                .replace(',', '.')
            : this.form.desconto || 0,
        ),
      };

      this.$vs.loading();
      autoApi
        .createEndorsementQuotation({ ...payload, ...updatePayload })
        .then(() => {
          if (!isTransmission) {
            this.endorsementJustCreatedInSession = true;
          }
          this.getQuotation();
          this.$vs.loading.close();

          if (isTransmission) {
            notify.notifySuccess(
              this.$vs,
              'Proposta de endosso transmitida com sucesso',
            );
            this.$router.push({ name: 'Cotações' });
            return;
          }
          notify.notifySuccess(
            this.$vs,
            'Cotação de endosso gerada com sucesso',
          );
        })
        .catch((error) => {
          this.handleCreateQuotationError(error, isTransmission);
        });
    },
    async recalculateEndorsement() {
      const formatedCharges = [];

      for (let carregamento of Object.keys(this.form.carregamentos)) {
        const charge = this.form.carregamentos[carregamento];
        formatedCharges.push({
          id: charge.idCarregamento,
          percentage: Number(charge.porcentagem),
        });
      }

      const payload = this.getBasePayload();

      const updatePayload = {
        charges: formatedCharges,
        coverage_products: [
          ...this.fieldsWithValidation.selectedProducts,
        ].filter((product) => product.quantity !== 0),
        discount: Number(
          typeof this.form.desconto === 'string'
            ? this.form.desconto
                .replace('R$ ', '')
                .replace('.', '')
                .replace(',', '.')
            : this.form.desconto || 0,
        ),
      };

      this.$vs.loading();

      try {
        const res = await autoApi.recalculateEndorsement({
          ...payload,
          ...updatePayload,
        });

        if (this.quotation && this.quotation.endorsement) {
          this.quotation.endorsement.prize = res.prize;
        }

        if (this.shouldFetchRefundCompensation) {
          await this.refreshRefundCompensation();
        } else {
          this.resetRefundCompensationData();
        }

        return res;
      } catch (error) {
        console.error(error);
        return null;
      } finally {
        this.$vs.loading.close();
      }
    },
    getBasePayload(isTransmission) {
      const formatedIncreases = [];

      for (let id of Object.keys(this.fieldsWithValidation.increasesAnswers)) {
        formatedIncreases.push({
          id: Number(id),
          answers: this.fieldsWithValidation.increasesAnswers[id].id,
        });
      }

      const [day, month, year] = this.fieldsWithValidation.driverBirthdate
        .split('/')
        .map(Number);
      const driverBirthdate = new Date(year, month - 1, day, 0, 0, 0);

      let insuredBirthdate = false;
      if (this.isPerson && this.fieldsWithValidation.birthDate) {
        const [dayInsured, monthInsured, yearInsured] =
          this.fieldsWithValidation.birthDate.split('/').map(Number);
        insuredBirthdate = new Date(
          yearInsured,
          monthInsured - 1,
          dayInsured,
          0,
          0,
          0,
        );
      }

      let startOfValidity = null;
      if (this.fieldsWithValidation.endorsement.startDate) {
        const [dayStartOfValidity, monthStartOfValidity, yearStartOfValidity] =
          this.fieldsWithValidation.endorsement.startDate
            .split('/')
            .map(Number);
        startOfValidity = new Date(
          yearStartOfValidity,
          monthStartOfValidity - 1,
          dayStartOfValidity,
          0,
          0,
          0,
        );
      }

      let endOfValidity = null;
      if (this.fieldsWithValidation.endOfValidity) {
        const [dayEndOfValidity, monthEndOfValidity, yearEndOfValidity] =
          this.fieldsWithValidation.endOfValidity.split('/').map(Number);
        endOfValidity = new Date(
          yearEndOfValidity,
          monthEndOfValidity - 1,
          dayEndOfValidity,
          0,
          0,
          0,
        );
      }

      let previousCoverageEndDate = null;
      if (this.fieldsWithValidation.previousCoverageEndDate) {
        const [dayEndOfValidity, monthEndOfValidity, yearEndOfValidity] =
          this.fieldsWithValidation.previousCoverageEndDate
            .split('/')
            .map(Number);
        previousCoverageEndDate = new Date(
          yearEndOfValidity,
          monthEndOfValidity - 1,
          dayEndOfValidity,
          0,
          0,
          0,
        );
      }

      let dateNf = null;

      if (this.fieldsWithValidation.vehicleInvoiceDate) {
        const [dayNf, monthNf, yearNf] =
          this.fieldsWithValidation.vehicleInvoiceDate.split('/').map(Number);
        dateNf = new Date(yearNf, monthNf - 1, dayNf, 0, 0, 0);
      }

      const paymentPayload =
        this.step === 0
          ? {
              payment_method_id: null,
              monthly_interest: null,
              installments: null,
              due_day: null,
              automatic_debit: null,
            }
          : {
              payment_method_id: this.fieldsWithValidation.selectedPayment
                ? this.fieldsWithValidation.selectedPayment.paymentMethodId
                : null,
              monthly_interest:
                this.fieldsWithValidation.payment.installments &&
                this.fieldsWithValidation.selectedPayment
                  ? this.fieldsWithValidation.selectedPayment.monthlyInterest[
                      this.fieldsWithValidation.payment.installments.id
                    ] || 0
                  : 0,
              installments: this.fieldsWithValidation.payment.installments
                ? this.fieldsWithValidation.payment.installments.id
                : 1,
              due_day: this.fieldsWithValidation.payment.dueDay,
              automatic_debit:
                this.fieldsWithValidation.selectedPayment &&
                this.fieldsWithValidation.selectedPayment.paymentMethodId ===
                  PAYMENT_METHODS.AUTOMATIC_DEBIT.id
                  ? {
                      bank: this.fieldsWithValidation.payment.automaticDebit
                        .bank,
                      agency:
                        this.fieldsWithValidation.payment.automaticDebit.agency,
                      account:
                        this.fieldsWithValidation.payment.automaticDebit
                          .account,
                      accountDigit:
                        this.fieldsWithValidation.payment.automaticDebit
                          .accountDigit,
                    }
                  : null,
            };

      return {
        previousPolicyId: this.quotation.id,
        endorsementOperationType: this.fieldsWithValidation.endorsement.method,
        policyNumber: this.quotation.policyNumber,
        start_of_validity: startOfValidity
          ? startOfValidity.toISOString().split('T')[0]
          : null,
        broker_id: this.brokerId,
        end_of_validity: endOfValidity
          ? endOfValidity.toISOString().split('T')[0]
          : null,
        prospect: {
          tax_id: this.fieldsWithValidation.cpfcnpj,
          name: this.fieldsWithValidation.name,
          social_name: this.fieldsWithValidation.socialName,
          civil_name: this.fieldsWithValidation.civilName,
          birthdate:
            this.isPerson && insuredBirthdate
              ? insuredBirthdate.toISOString().split('T')[0]
              : null,
          gender: this.fieldsWithValidation.gender,
          marital_status: this.fieldsWithValidation.maritalStatus,
          email: this.fieldsWithValidation.email,
          cellphone: this.fieldsWithValidation.cellphone,
          is_politically_exposed: this.isPoliticallyExposed,
          ppe_description: this.fieldsWithValidation.ppeDescription,
          state_registration_number: this.fieldsWithValidation.ie,
          address: {
            zip_code: this.fieldsWithValidation.address.zipCode
              ? this.fieldsWithValidation.address.zipCode.replace('.', '')
              : null,
            street: this.fieldsWithValidation.address.street,
            number: this.fieldsWithValidation.address.number,
            complement: this.fieldsWithValidation.address.complement,
            neighborhood: this.fieldsWithValidation.address.neighborhood,
            city: this.fieldsWithValidation.address.city,
            state: this.fieldsWithValidation.address.state,
            is_cep_api_result: this.fieldsWithValidation.address.cepApiResult,
          },
        },
        driver: {
          tax_id: this.fieldsWithValidation.driverCpfCnpj,
          name: this.fieldsWithValidation.driverName,
          social_name: this.fieldsWithValidation.driverSocialName,
          civil_name: this.fieldsWithValidation.driverCivilName,
          gender: this.fieldsWithValidation.driverGender,
          birthdate: driverBirthdate.toISOString().split('T')[0],
          email: this.fieldsWithValidation.driverEmail,
        },
        overnight_address: {
          zip_code: this.fieldsWithValidation.overnightAddress.zipCode.replace(
            '.',
            '',
          ),
          street: this.fieldsWithValidation.overnightAddress.street,
          neighborhood: this.fieldsWithValidation.overnightAddress.neighborhood,
          city: this.fieldsWithValidation.overnightAddress.city,
          state: this.fieldsWithValidation.overnightAddress.state,
          number: this.fieldsWithValidation.overnightAddress.number,
          complement: this.fieldsWithValidation.overnightAddress.complement,
          is_cep_api_result: this.overnightCepApiResult,
        },
        addition_information: {
          is_renovation: this.fieldsWithValidation.insuranceCompanyCode != '1',
          bonus: this.fieldsWithValidation.bonus,
          insurance_company_code:
            this.fieldsWithValidation.insuranceCompanyCode,
          policy_number: this.previousPolicyNumber,
          ci: this.fieldsWithValidation.ci,
          policy_document_bonus: this.policyDocumentBonus,
          previous_coverage_end_date: previousCoverageEndDate,
          is_same_vehicle: this.fieldsWithValidation.isSameVehicle,
        },
        vehicle: {
          type_id: Number(this.vehicleTypeId.id),
          brand_id: this.fieldsWithValidation.vehicleBrandId
            ? Number(this.fieldsWithValidation.vehicleBrandId.id)
            : null,
          model_id: this.fieldsWithValidation.vehicleModelId
            ? Number(this.fieldsWithValidation.vehicleModelId.id)
            : null,
          plate: this.fieldsWithValidation.vehiclePlate,
          chassis: this.fieldsWithValidation.vehicleChassis,
          coverageValue: Number(
            this.fieldsWithValidation.fipeResult.amount
              .replace('R$ ', '')
              .replace('.', '')
              .replace(',', '.'),
          ),
          is_brand_new: this.isBrandNew,
          invoice_number: this.fieldsWithValidation.vehicleInvoiceNumber,
          invoice_date: !this.fieldsWithValidation.vehicleInvoiceDate
            ? null
            : functions.formataDataHoraPadraoBR(dateNf.toISOString(), false),
          out_daelership: this.fieldsWithValidation.vehicleIsOutOfDealership,
          dealership_exit_date: this.getDealershipExitDate(),
          brand: this.vehicleBrand
            ? this.vehicleBrand
            : this.fieldsWithValidation.fipeResult.brand,
          model: this.vehicleModel
            ? this.vehicleModel
            : this.fieldsWithValidation.fipeResult.model,
          year_model: Number(this.fieldsWithValidation.vehicleYearModel.year),
          year_factory: Number(this.vehicleYearFactory),
          fipe_code: this.vehicleFipeCode
            ? this.vehicleFipeCode
            : this.fieldsWithValidation.fipeResult.fipe_code,
          color: this.vehicleColor,
          ports: this.vehiclePorts,
          engine_number: this.vehicleEngineNumber,
          renavam: this.vehicleRenavam,
          cylinder_capacity: Number(this.vehicleCylinderCapacity),
          fuel: this.vehicleFuel
            ? this.vehicleFuel
            : this.fieldsWithValidation.fipeResult.fuel,
          passenger_quantity: this.vehiclePassengerQuantity,
          plate_result: this.vehicleResult
            ? JSON.stringify(this.vehicleResult)
            : null,
          fipe_result: this.fieldsWithValidation.fipeResult
            ? JSON.stringify(this.fieldsWithValidation.fipeResult)
            : null,
          invoice_document: this.invoiceDocument,
        },
        increases: formatedIncreases,
        payment: paymentPayload,
        refundData: this.getRefundPayload(),
        isTransmission,
      };
    },
    getDealershipExitDate() {
      if (this.fieldsWithValidation.dealershipExitDate) {
        const [day, month, year] = this.fieldsWithValidation.dealershipExitDate
          .split('/')
          .map(Number);
        return new Date(year, month - 1, day, 0, 0, 0)
          .toISOString()
          .split('T')[0];
      }
      return null;
    },
    getBrokerAccountConfigs() {
      autoApi
        .getBrokerAccountConfigs()
        .then((res) => {
          this.brokerAccountConfigs = res;
          this.form.maximoDesconto = this.brokerAccountConfigs;
        })
        .catch(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi buscar as configurações da conta corrente',
            color: 'danger',
          });
        });
    },
    getDueDays() {
      autoApi
        .getDueDays()
        .then((res) => {
          if (res && Array.isArray(res)) {
            this.dueDays = res.sort((a, b) => a - b);
          }
        })
        .catch(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar os dias de vencimento',
            color: 'danger',
          });
        });
    },
    async getPaymentMethods() {
      paymentMethodConfigApi
        .getPaymentMethodConfigsByPolicy(this.quotation.id)
        .then((res) => {
          this.paymentMethods = res;
        })
        .catch(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar as formas de pagamento',
            color: 'danger',
          });
        });
    },
    updateModal() {
      if (this.quotation && this.quotation.id && this.quotation.proposal_id) {
        this.quotation.id = null;
        this.quotation.proposal_id = null;
      }
    },
    async getOriginalQuotation() {
      try {
        this.originalQuotation = await policyApi.getPolicyByNumber(
          this.id,
          true,
          true,
          false,
        );
      } catch (error) {
        console.error('ERRO COTAÇÃO ORIGINAL', error);
      }
    },
    async getQuotation() {
      this.$vs.loading();
      this.updateModal();
      try {
        const res = await this.fetchPolicy();

        this.fillMainData(res);
        await this.getPaymentMethods();
        this.fillPaymentData(res);

        await this.setInstallmentsSelected();

        this.fillProspectData(res);
        this.fillDriverData(res);
        this.fillAddressData(res);
        this.fillVehicleData(res);
        this.fillIncreases(res);
        this.fillCoverages(res);
        if (res.endorsement && res.endorsement.refundData) {
          this.fillRefundData(res.endorsement.refundData);
        }

        this.handleEndorsementStep(res);
        await this.refreshRefundCompensation();

        this.getVehicleBrands();
        this.addDealershipExitDateValidation();
        this.addMin30DaysValidation();
      } catch (e) {
        console.error('ERRO COTACAO', e);
        await this.$router.push({ name: 'pageError404' });
      } finally {
        this.getCongeners(this.fieldsWithValidation.insuranceCompanyCode);
        this.$vs.loading.close();
      }
    },
    fetchPolicy() {
      if (this.proposalId) {
        return autoApi.getQuotation(this.proposalId);
      }
      return policyApi.getPolicyByNumber(this.id, true, false, false);
    },
    async getPolicyNumberFromProposal() {
      try {
        const quotation = await autoApi.getQuotation(this.proposalId);
        const policyNumber = quotation.policyNumber;

        if (!policyNumber) {
          throw new Error('Número da apólice não encontrado');
        }

        return policyNumber;
      } catch (error) {
        console.error('Erro ao buscar proposta para endosso', error);
        if (error.response.status === 404) {
          return this.proposalId;
        }
        notify.notifyFail(
          this.$vs,
          'Não foi possível localizar a apólice desta proposta.',
        );
        await this.$router.push({ name: 'pageError404' });
        return null;
      }
    },
    async redirectToOpenEndorsementProposal(policyNumber) {
      try {
        const openProposal =
          await autoApi.getOpenEndorsementQuotationByPolicyNumber(policyNumber);

        if (
          !openProposal ||
          !openProposal.hasOpenEndorsementProposal ||
          !openProposal.proposalId
        ) {
          return false;
        }

        const queryWithoutIdentifierType = { ...this.$route.query };
        delete queryWithoutIdentifierType.identifierType;

        await this.$router.replace({
          name: 'endosso',
          params: { id: String(openProposal.proposalId) },
          query: queryWithoutIdentifierType,
        });

        return true;
      } catch (error) {
        console.error('Erro ao validar proposta de endosso em aberto', error);
        return false;
      }
    },
    async fetchOriginalPolicy() {
      this.originalPolicy = await policyApi.getOriginalPolicyByNumber(this.id);
    },
    fillMainData(res) {
      this.quotation = res;
      this.brokerId = res.broker.id;
      this.insuredIsMainDriver = res.prospect.tax_id === res.driver.tax_id;

      this.fieldsWithValidation.startOfValidity =
        dateConversion.convertISOToDate(res.start_of_validity);
      this.fieldsWithValidation.endOfValidity = dateConversion.convertISOToDate(
        res.end_of_validity,
      );
      this.fieldsWithValidation.ci = res.addition_information.ci;
      this.fieldsWithValidation.insuranceCompanyCode =
        res.addition_information.insurance_company_code;
      this.fieldsWithValidation.policyNumber =
        res.addition_information.policy_number;
      this.policyNumber =
        res.addition_information.policy_number || res.policyNumber;
      this.previousPolicyNumber = res.addition_information.policy_number;
      this.policyDocumentBonus = res.addition_information.policy_document_bonus;
      this.fieldsWithValidation.isSameVehicle = res.vehicle.is_brand_new
        ? false
        : res.addition_information.is_same_vehicle;
      this.fieldsWithValidation.previousCoverageEndDate =
        dateConversion.convertISOToDate(
          res.addition_information.previous_coverage_end_date,
        );

      this.key = res.key;
      this.isRenovation = res.addition_information.is_renovation;
      this.fieldsWithValidation.bonus = res.addition_information.bonus;
    },
    fillProspectData(res) {
      this.fieldsWithValidation.cpfcnpj = res.prospect.tax_id;
      this.fieldsWithValidation.name = res.prospect.name;
      this.fieldsWithValidation.socialName = res.prospect.social_name;
      this.fieldsWithValidation.civilName = res.prospect.civil_name;
      this.fieldsWithValidation.birthDate = dateConversion.convertISOToDate(
        res.prospect.birthdate,
      );
      this.fieldsWithValidation.gender = res.prospect.gender;
      this.fieldsWithValidation.maritalStatus = res.prospect.marital_status;
      this.fieldsWithValidation.cellphone = res.prospect.cellphone;
      this.fieldsWithValidation.email = res.prospect.email;
      this.isPoliticallyExposed = res.prospect.is_politically_exposed;
      this.fieldsWithValidation.ppeDescription = res.prospect.ppe_description;
      this.fieldsWithValidation.ie = res.prospect.stateRegistrationNumber;

      const address = res.prospect.address;
      this.fieldsWithValidation.address.zipCode = address.zip_code;
      this.fieldsWithValidation.address.street = address.street;
      this.fieldsWithValidation.address.number = address.number;
      this.fieldsWithValidation.address.complement = address.complement;
      this.fieldsWithValidation.address.neighborhood = address.neighborhood;
      this.fieldsWithValidation.address.city = address.city;
      this.fieldsWithValidation.address.state = address.state;
      this.fieldsWithValidation.address.cepApiResult =
        address.is_cep_api_result;
    },
    fillPaymentData(res) {
      this.fieldsWithValidation.selectedPayment = this.paymentMethods.find(
        function (pay) {
          return pay.id == res.payment.payment_method_id;
        },
      );

      this.fieldsWithValidation.payment.installments = {
        id: res.payment.installments,
      };

      this.fieldsWithValidation.payment.dueDay = res.payment.due_day;

      if (res.payment.automatic_debit) {
        this.fieldsWithValidation.payment.automaticDebit.bank =
          res.payment.automatic_debit.bank;
        this.fieldsWithValidation.payment.automaticDebit.agency =
          res.payment.automatic_debit.agency;
        this.fieldsWithValidation.payment.automaticDebit.account =
          res.payment.automatic_debit.account;
        this.fieldsWithValidation.payment.automaticDebit.accountDigit =
          res.payment.automatic_debit.accountDigit;
      }
    },
    fillDriverData(res) {
      this.fieldsWithValidation.driverCpfCnpj = res.driver.tax_id;
      this.fieldsWithValidation.driverName = res.driver.name;
      this.fieldsWithValidation.driverSocialName = res.driver.social_name;
      this.fieldsWithValidation.driverCivilName = res.driver.civil_name;
      this.fieldsWithValidation.driverGender = res.driver.gender;
      this.fieldsWithValidation.driverBirthdate =
        dateConversion.convertISOToDate(res.driver.birthdate);
      this.fieldsWithValidation.driverEmail = res.driver.email;
    },
    fillAddressData(res) {
      const addr = res.overnight_address;

      this.fieldsWithValidation.overnightAddress.zipCode = addr.zip_code;
      this.fieldsWithValidation.overnightAddress.street = addr.street;
      this.fieldsWithValidation.overnightAddress.neighborhood =
        addr.neighborhood;
      this.fieldsWithValidation.overnightAddress.city = addr.city;
      this.fieldsWithValidation.overnightAddress.state = addr.state;
      this.fieldsWithValidation.overnightAddress.number = addr.number;
      this.fieldsWithValidation.overnightAddress.complement = addr.complement;
      this.fieldsWithValidation.overnightAddress.cepApiResult =
        addr.is_cep_api_result;
    },
    fillVehicleData(res) {
      const vehicle = res.vehicle;

      this.vehicleTypeId = this.vehicleTypes.find(function (vehicleType) {
        return vehicleType.id === vehicle.type_id;
      });

      this.fieldsWithValidation.vehicleBrandId = { id: vehicle.brand_id };
      this.fieldsWithValidation.vehicleModelId = { id: vehicle.model_id };
      this.fieldsWithValidation.vehicleYearModel = { year: vehicle.year_model };

      this.vehicleGroupId = vehicle.group_id;
      this.fieldsWithValidation.vehiclePlate = vehicle.plate;
      this.fieldsWithValidation.vehicleChassis = vehicle.chassis;
      this.isBrandNew = vehicle.is_brand_new;
      this.fieldsWithValidation.vehicleInvoiceDate = vehicle.invoice_date;
      this.fieldsWithValidation.vehicleIsOutOfDealership =
        vehicle.out_daelership;

      this.fieldsWithValidation.dealershipExitDate =
        vehicle.dealership_exit_date
          ? vehicle.dealership_exit_date.split('-').reverse().join('/')
          : null;

      this.fieldsWithValidation.vehicleInvoiceNumber = vehicle.invoice_number;

      this.vehicleBrand = vehicle.brand;
      this.fieldsWithValidation.vehicleBrandId.label = vehicle.brand;

      this.vehicleModel = vehicle.model;
      this.fieldsWithValidation.vehicleModelId.label = vehicle.model;

      this.vehicleYearFactory = vehicle.year_factory;
      this.fieldsWithValidation.vehicleYearModel.label = vehicle.year_model;

      this.vehicleFipeCode = vehicle.fipe_code;
      this.vehicleColor = vehicle.color;
      this.vehiclePorts = vehicle.ports;
      this.vehicleEngineNumber = vehicle.engine_number;
      this.vehicleRenavam = vehicle.renavam;
      this.vehicleCylinderCapacity = vehicle.cylinder_capacity;
      this.vehicleFuel = vehicle.fuel;
      this.vehiclePassengerQuantity = vehicle.passenger_quantity;

      this.fieldsWithValidation.fipeResult = vehicle.fipe_result;
      this.vehicleResult = vehicle.plate_result;
      this.invoiceDocument = vehicle.invoice_document;

      if (vehicle.plate_result) {
        this.selectedFipeModel = vehicle.plate_result.fipe_data.find(function (
          fipe,
        ) {
          return fipe.fipe_code === vehicle.fipe_result.fipe_code;
        });
      }
    },
    fillIncreases(res) {
      this.increases = res.all_increases.increases;
      this.zipCodeIncreases = res.all_increases.zipCodeIncreases;

      for (var i = 0; i < res.increases_answers.length; i++) {
        var increase = res.increases_answers[i];

        var increaseComplete = this.increases.find(function (inc) {
          return inc.id === increase.id;
        });

        var response = increaseComplete.answers.find(function (ans) {
          return ans.id === increase.answers;
        });

        this.$set(
          this.fieldsWithValidation.increasesAnswers,
          increase.id,
          response,
        );
      }
    },
    fillCoverages(res) {
      this.quoatiotionGenerated = true;
      this.prize = res.prize;

      this.products = res.all_coverages.details;

      if (res.coverage_contracted.length > 0) {
        this.fieldsWithValidation.selectedProducts = [].concat(
          res.coverage_contracted,
        );
        this.selectedProducts = [].concat(res.coverage_contracted);
      } else {
        this.setDefaultSelectedProducts();
      }

      res.charges.forEach((charge) => {
        this.form.carregamentos[charge.label] = {
          idCarregamento: charge.id,
          label: charge.label,
          porcentagem: charge.percentage,
          createdAt: charge.createdAt,
          updatedAt: charge.updatedAt,
          deletedAt: charge.deletedAt,
        };
      });

      this.form.desconto = res.prize.discount;
    },
    fillRefundData(refundData) {
      this.fieldsWithValidation.refundData.bankId = refundData.bankId;
      this.fieldsWithValidation.refundData.account = refundData.account;
      this.fieldsWithValidation.refundData.accountDigit =
        refundData.accountDigit;
      this.fieldsWithValidation.refundData.agency = refundData.agency;
      this.fieldsWithValidation.refundData.holderDocument =
        refundData.holderDocument;
      this.fieldsWithValidation.refundData.holderName = refundData.holderName;
      this.fieldsWithValidation.refundData.pixKey = refundData.pixKey;
    },
    handleEndorsementStep(res) {
      if (this.isNewFromPolicyIdentifier) {
        this.blockSelectOperation = false;
        const isPendingEndorsementResult =
          res.creationType === POLICY_CREATION_TYPE.ENDORSEMENT.value &&
          res.endorsement &&
          res.endorsement.effectiveDate === null;

        if (
          this.endorsementJustCreatedInSession &&
          isPendingEndorsementResult
        ) {
          this.step = 1;
          this.endorsementJustCreatedInSession = false;
          return;
        }

        this.step = 0;
        return;
      }

      if (res.endorsement && res.endorsement.operationTypeId) {
        const selectedOperation = this.operationTypes.find(function (op) {
          return op.id === res.endorsement.operationTypeId;
        });
        if (selectedOperation) {
          this.fieldsWithValidation.endorsement.method = selectedOperation;
          this.blockSelectOperation = true;
        }
      }
      if (res.endorsement && res.endorsement.startDate) {
        this.fieldsWithValidation.endorsement.startDate =
          dateConversion.convertISOToDate(res.endorsement.startDate);
      }
      if (
        res.creationType === 'NEW_POLICY' ||
        (res.endorsement && res.endorsement.number !== null)
      ) {
        this.step = 0;
      }

      if (
        res.creationType === 'ENDORSEMENT' &&
        res.endorsement &&
        res.endorsement.effectiveDate === null
      ) {
        this.step = 1;
      }
    },
    getCharges() {
      autoApi
        .getCharges()
        .then((res) => {
          res.map((charge) => {
            this.form.carregamentos[charge.label] = {
              idCarregamento: charge.id,
              label: charge.label,
              porcentagem: charge.default,
              createdAt: charge.createdAt,
              updatedAt: charge.updatedAt,
              deletedAt: charge.deletedAt,
            };
          });
        })
        .catch(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar as corretoras',
            color: 'danger',
          });
        });
    },
    getVehicleTypes() {
      autoApi
        .getVehicleTypes()
        .then((res) => {
          this.vehicleTypes = res;
        })
        .catch((e) => {
          console.error(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar os tipos de veículos',
            color: 'danger',
          });
        });
    },
    getVehicleBrands() {
      autoApi
        .getVehicleBrands(this.vehicleTypeId.id)
        .then((res) => {
          this.vehicleBrands = res.map((brand) => {
            return {
              id: brand.id,
              label: brand.brand,
            };
          });

          if (this.fieldsWithValidation.vehicleBrandId) {
            const brandId = this.vehicleBrands.find((brand) => {
              return brand.id == this.fieldsWithValidation.vehicleBrandId.id;
            });

            if (brandId) {
              this.fieldsWithValidation.vehicleBrandId = brandId;
              this.getVehicleModels();
            }
          }
        })
        .catch((e) => {
          console.error(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar as marcas',
            color: 'danger',
          });
        });
    },
    getVehicleModels() {
      if (!this.fieldsWithValidation.vehicleBrandId) {
        return this.getVehicleBrands();
      }

      autoApi
        .getVehicleModels(
          this.vehicleTypeId.id,
          this.fieldsWithValidation.vehicleBrandId.id,
        )
        .then((res) => {
          this.vehicleModels = res.models.map((model) => {
            return {
              id: model.id,
              label: model.model,
            };
          });

          this.vehicleYearsModel = res.years.map((year) => {
            return {
              id: year.year,
              label: year.year,
              fuel: year.fuel,
              year: year.id,
            };
          });

          if (
            this.fieldsWithValidation.vehicleModelId &&
            this.fieldsWithValidation.vehicleYearModel
          ) {
            this.fieldsWithValidation.vehicleModelId = this.vehicleModels.find(
              (model) => {
                return model.id == this.fieldsWithValidation.vehicleModelId.id;
              },
            );

            this.fieldsWithValidation.vehicleYearModel =
              this.vehicleYearsModel.find((year) => {
                return (
                  year.year == this.fieldsWithValidation.vehicleYearModel.year
                );
              });
          }
        })
        .catch((e) => {
          console.error(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar os anos modelo',
            color: 'danger',
          });
        });
    },
    getVehicleYears() {
      if (!this.fieldsWithValidation.vehicleModelId) {
        this.fieldsWithValidation.fipeResult = null;
        return this.getVehicleModels();
      }

      autoApi
        .getVehicleYears(
          this.vehicleTypeId.id,
          this.fieldsWithValidation.vehicleBrandId.id,
          this.fieldsWithValidation.vehicleModelId.id,
        )
        .then((res) => {
          this.vehicleYearsModel = res.map((year) => {
            return {
              id: year.year,
              label: year.year,
              fuel: year.fuel,
              year: year.id,
            };
          });

          if (this.fieldsWithValidation.vehicleYearModel) {
            const hasYear = this.vehicleYearsModel.some(
              (year) =>
                year.id == this.fieldsWithValidation.vehicleYearModel.id,
            );

            if (!hasYear) {
              this.fieldsWithValidation.vehicleYearModel = null;
            }

            if (
              this.fieldsWithValidation.vehicleModelId &&
              this.fieldsWithValidation.vehicleYearModel
            ) {
              return this.getFipe();
            }
          }
        })
        .catch((e) => {
          console.error(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar os anos modelo',
            color: 'danger',
          });
        });
    },
    getVehicleModelsByYear() {
      if (!this.fieldsWithValidation.vehicleYearModel) {
        this.fieldsWithValidation.fipeResult = null;
        return this.getVehicleModels();
      }

      this.vehicleFuelId = this.fieldsWithValidation.vehicleYearModel.fuel;

      autoApi
        .getVehicleModelsByYear(
          this.vehicleTypeId.id,
          this.fieldsWithValidation.vehicleBrandId.id,
          this.fieldsWithValidation.vehicleYearModel.year,
        )
        .then((res) => {
          this.vehicleModels = res.map((model) => {
            return {
              id: model.id,
              label: model.model,
            };
          });
          if (this.fieldsWithValidation.vehicleModelId) {
            const hasModel = this.vehicleModels.some(
              (model) =>
                model.id == this.fieldsWithValidation.vehicleModelId.id,
            );

            if (!hasModel) {
              this.fieldsWithValidation.vehicleModelId = null;
            }

            if (
              this.fieldsWithValidation.vehicleModelId &&
              this.fieldsWithValidation.vehicleYearModel
            ) {
              return this.getFipe();
            }
          }
        })
        .catch((e) => {
          console.error(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar os modelos',
            color: 'danger',
          });
        });
    },
    getFipe() {
      const vehicleYearModelId = this.isBrandNew
        ? ZERO_KM_VEHICLE_YEAR_ID
        : this.fieldsWithValidation.vehicleYearModel.year;
      autoApi
        .getFipe(
          this.vehicleTypeId.id,
          this.fieldsWithValidation.vehicleBrandId.id,
          this.fieldsWithValidation.vehicleModelId.id,
          vehicleYearModelId,
          this.vehicleFuelId,
        )
        .then((res) => {
          if (res && res.amount) {
            this.fieldsWithValidation.fipeResult = res;
          } else {
            this.fieldsWithValidation.fipeResult = { amount: 0 };
          }
          this.getIncreases();
        })
        .catch((e) => {
          console.error(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar a Tabela FIPE',
            color: 'danger',
          });
        });
    },
    async getFipeByCode() {
      const vehicleYearModelId = this.isBrandNew
        ? ZERO_KM_VEHICLE_YEAR_ID
        : this.fieldsWithValidation.vehicleYearModel.year;
      autoApi
        .getFipeByCode(
          this.vehicleTypeId.id,
          vehicleYearModelId,
          this.vehicleFuelId,
          this.vehicleFipeCode,
        )
        .then((res) => {
          this.fieldsWithValidation.fipeResult = res;
          this.getIncreases();
        })
        .catch((e) => {
          console.error(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar a Tabela FIPE',
            color: 'danger',
          });
        });
    },
    chanceFipeResult() {
      this.fieldsWithValidation.fipeResult = {
        amount: this.selectedFipeModel.value_text,
        brand: this.selectedFipeModel.brand_text,
        fipe_code: this.selectedFipeModel.fipe_code,
        fuel: this.selectedFipeModel.fuel || this.selectedFipeModel.fuel_code,
        fuel_initials: this.selectedFipeModel.fuel_abbreviation,
        model: this.selectedFipeModel.model_text,
        vehicle_type: this.selectedFipeModel.type_id,
        year_model: Number(this.selectedFipeModel.year_model),
      };
    },
    getIncreases() {
      if (!this.fieldsWithValidation.overnightAddress.zipCode) return;

      autoApi
        .getIncreases(this.fieldsWithValidation.overnightAddress.zipCode)
        .then((res) => {
          this.increases = res.increases;
          this.zipCodeIncreases = res.zipCodeIncreases;
        })
        .catch(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar as coberturas',
            color: 'danger',
          });
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });

        this[array].sort(function (a, b) {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
        this[array].unshift({ id: null, label: 'Selecione' });
      });
    },
    async setVehicleAndCalculate(selectedVehicleModel) {
      await this.setSelectedVehicleModel(selectedVehicleModel);
      const newProducts = await this.recalculateEndorsement();
      if (!newProducts || !newProducts.newCalculatedPrize) {
        return;
      }
      this.products = newProducts.newCalculatedPrize.prize.details;
    },
    async setSelectedVehicleModel(selectedVehicleModel) {
      if (!selectedVehicleModel) {
        this.showSelectPlateModal = false;
        this.resetModalVehicleModel = false;

        this.selectedFipeModel = null;
        this.fieldsWithValidation.vehicleBrandId = null;
        this.fieldsWithValidation.vehicleModelId = null;
        this.vehicleFuelId = null;
        this.fieldsWithValidation.vehicleYearModel = null;
        this.vehicleBrand = null;
        this.vehicleModel = null;
        this.vehicleFipeCode = null;
        this.fieldsWithValidation.fipeResult = null;
        this.vehicleTypeId = this.vehicleTypes.find(
          (vehicleType) =>
            vehicleType.id === this.vehicleResult.fipe_data[0].type_id,
        );
        return;
      }

      this.selectedFipeModel = selectedVehicleModel;
      if (
        this.selectedFipeModel.fuel_code &&
        this.selectedFipeModel.fuel_code === FUEL_TYPE_CODES.ELECTRIC
      ) {
        this.selectedFipeModel.fuel = FUEL_TYPE_NAMES.ELECTRIC;
        this.vehicleFuel = this.selectedFipeModel.fuel;
      }
      this.vehicleTypeId = this.vehicleTypes.find(
        (vehicleType) => vehicleType.id === this.selectedFipeModel.type_id,
      );

      this.fieldsWithValidation.vehicleBrandId = {
        id: this.selectedFipeModel.brand_id,
        label: this.selectedFipeModel.brand_text,
      };

      this.fieldsWithValidation.vehicleModelId = {
        id: this.selectedFipeModel.model_id,
        label: this.selectedFipeModel.model_text,
      };
      this.vehicleFuelId =
        this.fuelCode[this.selectedFipeModel.fuel_abbreviation];
      const yearModelLabel = this.getVehicleYearModelLabel(
        this.selectedFipeModel,
      );
      this.fieldsWithValidation.vehicleYearModel = {
        id: yearModelLabel,
        label: yearModelLabel,
        fuel: this.selectedFipeModel.fuel,
        year: this.selectedFipeModel.year_model,
      };
      this.vehicleModel = this.selectedFipeModel.model_text;
      this.vehicleFipeCode = this.selectedFipeModel.fipe_code;
      if (this.selectedFipeModel.correct_data && !this.isBrandNew) {
        this.chanceFipeResult();
      } else {
        await this.getFipeByCode();
      }
      this.showSelectPlateModal = false;
      this.resetModalVehicleModel = false;
    },
    keymonitorPlate: async function () {
      if (
        !this.fieldsWithValidation.vehiclePlate ||
        this.fieldsWithValidation.vehiclePlate.length < 8 ||
        this.searchingPlate
      ) {
        this.clearVehicleData();
        return;
      }

      this.clearVehicleData();
      this.searchingPlate = true;
      this.$vs.loading();

      autoApi
        .getVehicleByPlate(this.fieldsWithValidation.vehiclePlate)
        .then((res) => {
          if (!res) {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Nenhum modelo encontrado com essa placa ou chassi.',
              color: 'danger',
            });
            this.clearVehicleData();
            this.searchingPlate = false;
            this.vehicleFound = false;

            return;
          }

          this.searchingPlate = false;
          this.vehicleFound = true;
          this.vehicleResult = res;

          this.fieldsWithValidation.vehicleChassis =
            this.vehicleResult.extra_data.chassis_number;
          this.vehicleEngineNumber = this.vehicleResult.extra_data.motor;
          this.vehicleCylinderCapacity =
            this.vehicleResult.extra_data.cylinder_capacity;
          this.vehicleFuel = this.vehicleResult.extra_data.fuel;
          this.vehiclePassengerQuantity =
            this.vehicleResult.extra_data.passenger_count;
          this.vehicleBrand = this.vehicleResult.brand;
          this.vehicleYearFactory = this.vehicleResult.year;
          this.vehicleColor = this.vehicleResult.color;
          this.vehicleRenavam = this.vehicleResult.extra_data.renavam;

          this.selectedFipeModel = null;
          if (
            res &&
            this.fieldsWithValidation.vehiclePlate &&
            this.fieldsWithValidation.vehiclePlate.length === 8
          ) {
            this.resetModalVehicleModel = true;
            this.showSelectPlateModal = true;
          }
        })
        .catch(() => {
          this.vehicleFound = false;
          this.searchingPlate = false;
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar os dados do veículo',
            color: 'danger',
          });
        })
        .finally(() => this.$vs.loading.close());
    },
    async keymonitorChassi() {
      if (this.isBrandNew) {
        if (
          !this.fieldsWithValidation.vehicleChassis ||
          this.fieldsWithValidation.vehicleChassis.length < 17 ||
          this.searchingChassi
        ) {
          this.clearVehicleDataWithOutChassi();
          return;
        }

        this.$vs.loading();

        autoApi
          .getVehicleByChassi(this.fieldsWithValidation.vehicleChassis)
          .then((res) => {
            this.searchingChassi = false;
            this.vehicleFound = true;
            this.vehicleResult = res;

            this.fieldsWithValidation.vehicleChassis =
              this.vehicleResult.extra_data.chassis_number;
            this.vehicleEngineNumber = this.vehicleResult.extra_data.motor;
            this.vehicleCylinderCapacity =
              this.vehicleResult.extra_data.cylinder_capacity;
            this.vehicleFuel = this.vehicleResult.extra_data.fuel;
            this.vehiclePassengerQuantity =
              this.vehicleResult.extra_data.passenger_count;
            this.vehicleBrand = this.vehicleResult.brand;
            this.vehicleYearFactory = this.vehicleResult.year;
            this.vehicleColor = this.vehicleResult.color;
            this.vehicleRenavam = this.vehicleResult.extra_data.renavam;

            this.selectedFipeModel = null;
            if (res) {
              this.resetModalVehicleModel = true;
              this.showSelectPlateModal = true;
            }
          })
          .catch(() => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Nenhum modelo encontrado com essa placa ou chassi.',
              color: 'danger',
            });

            this.searchingPlate = false;
            this.vehicleFound = false;
            this.clearVehicleDataWithOutChassi();
          })
          .finally(() => this.$vs.loading.close());
      }
    },
    clearAddressData(addressType) {
      this.fieldsWithValidation[addressType].cepApiResult = false;
      this.fieldsWithValidation[addressType].street = null;
      this.fieldsWithValidation[addressType].neighborhood = null;
      this.fieldsWithValidation[addressType].city = null;
      this.fieldsWithValidation[addressType].state = null;
      this.fieldsWithValidation[addressType].number = null;
      this.fieldsWithValidation[addressType].complement = null;

      const prefix = addressType === 'overnightAddress' ? 'Overnight' : '';
      this[`hasCepApiReturned${prefix}Street`] = false;
      this[`hasCepApiReturned${prefix}Neighborhood`] = false;
      this[`hasCepApiReturned${prefix}State`] = false;
      this[`hasCepApiReturned${prefix}City`] = false;
    },
    handleCepChanges(addressType) {
      if (!this.fieldsWithValidation[addressType].zipCode) {
        this.clearAddressData(addressType);
        return;
      }

      if (this.fieldsWithValidation[addressType].zipCode.length !== 10) {
        return;
      }

      this.$vs.loading();

      this.getIncreases();

      var cepbusca = this.fieldsWithValidation[addressType].zipCode
        .replace('.', '')
        .replace('-', '');
      service
        .post('g', 'BuscaCEP', {
          cep: cepbusca,
        })
        .then((res) => {
          this.fieldsWithValidation[addressType].cepApiResult = !!res.data;
          this.fieldsWithValidation[addressType].street = res.data.street;
          this.fieldsWithValidation[addressType].neighborhood =
            res.data.neighborhood;
          this.fieldsWithValidation[addressType].city = res.data.city;
          this.fieldsWithValidation[addressType].state = res.data.state;
          this.fieldsWithValidation[addressType].number = null;
          this.fieldsWithValidation[addressType].complement = null;

          const prefix = addressType === 'overnightAddress' ? 'Overnight' : '';
          this[`hasCepApiReturned${prefix}Street`] =
            this.fieldsWithValidation[addressType].street !== '';
          this[`hasCepApiReturned${prefix}Neighborhood`] =
            this.fieldsWithValidation[addressType].neighborhood !== '';
          this[`hasCepApiReturned${prefix}State`] =
            this.fieldsWithValidation[addressType].state !== '';
          this[`hasCepApiReturned${prefix}City`] =
            this.fieldsWithValidation[addressType].city !== '';

          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.clearAddressData(addressType);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível encontrar o cep',
            color: 'danger',
          });
        });
    },
    getCityDataInsured(model, array, campoDescricao, campoPK) {
      this.fieldsWithValidation.address.city = null;
      if (!this.fieldsWithValidation.address.state) {
        this[array] = [];
        return;
      }

      this[array] = [];
      if (
        this.fieldsWithValidation.address.state &&
        this.fieldsWithValidation.address.state.id
      ) {
        this.$vs.loading();

        service
          .getAll(
            'g',
            {},
            `${model}/list/codUf/${this.fieldsWithValidation.address.state.id}`,
          )
          .then((res) => {
            if (res)
              res.data.forEach((element) => {
                this[array].push({
                  id: element[campoPK],
                  label: element[campoDescricao],
                });
              });

            this.$vs.loading.close();
          });
      }
    },
    selectStateInsured() {
      if (!this.fieldsWithValidation.address.state) {
        return;
      }

      const aux = this.estados.find(
        (x) => x.id === this.fieldsWithValidation.address.state.id,
      );
      this.fieldsWithValidation.address.state = aux.label;
    },
    selectCityInsured() {
      if (!this.fieldsWithValidation.address.city) {
        this.fieldsWithValidation.address.city = null;
        return;
      }

      var aux = this.cidades.find(
        (x) => x.id === this.fieldsWithValidation.address.city.id,
      );
      this.fieldsWithValidation.address.city = aux.label;
    },
    getCityData(model, array, campoDescricao, campoPK) {
      this.fieldsWithValidation.overnightAddress.city = null;
      if (!this.fieldsWithValidation.overnightAddress.state) {
        this[array] = [];
        return;
      }

      this.$vs.loading();
      this[array] = [];
      if (
        this.fieldsWithValidation.overnightAddress.state &&
        this.fieldsWithValidation.overnightAddress.state.id
      ) {
        this.$vs.loading();

        service
          .getAll(
            'g',
            {},
            `${model}/list/codUf/${this.fieldsWithValidation.overnightAddress.state.id}`,
          )
          .then((res) => {
            if (res)
              res.data.forEach((element) => {
                this[array].push({
                  id: element[campoPK],
                  label: element[campoDescricao],
                });
              });

            this.$vs.loading.close();
          });
      }
    },
    selectState() {
      if (!this.fieldsWithValidation.overnightAddress.state) {
        return;
      }

      const aux = this.estados.find(
        (x) => x.id === this.fieldsWithValidation.overnightAddress.state.id,
      );
      this.fieldsWithValidation.overnightAddress.state = aux.label;
    },
    selectCity() {
      if (!this.fieldsWithValidation.overnightAddress.city) {
        this.fieldsWithValidation.overnightAddress.city = null;
        return;
      }

      var aux = this.cidades.find(
        (x) => x.id === this.fieldsWithValidation.overnightAddress.city.id,
      );
      this.fieldsWithValidation.overnightAddress.city = aux.label;
    },
    converteParams() {
      if (this.$route.query.hideLogo) {
        this.hideLogo = JSON.parse(this.$route.query.hideLogo.toLowerCase());
      } else this.hideLogo = false;

      if (this.$route.query.showPanel) {
        this.showPanel = JSON.parse(this.$route.query.showPanel.toLowerCase());
      } else this.showPanel = true;

      if (this.$route.query.fixedButton) {
        this.fixedButton = JSON.parse(
          this.$route.query.fixedButton.toLowerCase(),
        );
      } else this.fixedButton = false;

      if (this.$route.query.isRedirect) {
        this.isRedirect = JSON.parse(
          this.$route.query.isRedirect.toLowerCase(),
        );
      } else this.isRedirect = true;
    },
    getQuotationConfigs() {
      autoApi
        .getQuotationConfigs()
        .then((res) => {
          this.listAllowedStates = res.statesAllowed
            .replace(' ', '')
            .split(',');
          this.maxRcfCoverageValue = res.maxRcfCoverageValue;
          this.createDynamicValidations();
        })
        .catch(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível buscar as configurações de cotação',
            color: 'danger',
          });
        });
    },
    getCongeners(susep_code) {
      autoApi
        .getCongenersLabeled(susep_code)
        .then((res) => {
          res.forEach((congener) => {
            this.insuranceCompanies.push({
              id: congener.susep_code,
              label: congener.name,
            });
          });
        })
        .catch(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível buscar a lista de congêneres',
            color: 'danger',
          });
        });
    },
    clearRefundData() {
      this.fieldsWithValidation.refundData.bankId = null;
      this.fieldsWithValidation.refundData.agency = null;
      this.fieldsWithValidation.refundData.account = null;
      this.fieldsWithValidation.refundData.accountDigit = null;
      this.fieldsWithValidation.refundData.pixKey = null;
      this.fieldsWithValidation.refundData.holderName = null;
      this.fieldsWithValidation.refundData.holderDocument = null;
    },
    async isValidPolicyStatus() {
      try {
        this.policyStatus = await policyApi.getPolicyStatusByNumber(this.id);
        if (
          ![POLICY_STATUSES.ACTIVE.id, POLICY_STATUSES.CANCELED.id].includes(
            this.policyStatus,
          )
        ) {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },
    validateFilledStartOfValidity() {
      if (
        this.fieldsWithValidation.endorsement.startDate &&
        this.fieldsWithValidation.endorsement.method &&
        !this.fieldsWithValidation.endorsement.method.acceptsRetroactiveValidity
      ) {
        this.endorsementStartDateConfig.minDate =
          this.fieldsWithValidation.endorsement.startDate;
      }
    },
  },
  async created() {
    if (!this.checkAccessPermission()) {
      return;
    }
    this.getEndormentOperationTypes();
    this.getCharges();
    this.getVehicleTypes();
    this.getBrokerAccountConfigs();
    this.getQuotationConfigs();
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    await functions.buscaDadosSelects(
      'domBancos',
      this.refundBankOptions,
      'LongName',
      'idBanco',
    );
    this.converteParams();
    this.getDueDays();

    if (this.$route.params.id) {
      const identifierType = this.$route.query.identifierType;
      this.isNewFromPolicyIdentifier = identifierType === 'policy';

      if (this.isNewFromPolicyIdentifier) {
        const policyNumber = this.$route.params.id;
        const redirectedToOpenProposal =
          await this.redirectToOpenEndorsementProposal(policyNumber);

        if (redirectedToOpenProposal) {
          return;
        }

        this.id = policyNumber;
        this.policyNumber = policyNumber;
        await this.getOriginalQuotation();
        await this.fetchOriginalPolicy();
        await this.getQuotation();
      } else {
        this.proposalId = this.$route.params.id;
        const policyNumber = await this.getPolicyNumberFromProposal();

        if (!policyNumber) {
          throw new Error('Número da apólice não encontrado para a proposta');
        }

        this.id = policyNumber;
        this.policyNumber = policyNumber;
        await this.getOriginalQuotation();
        await this.fetchOriginalPolicy();
        await this.getQuotation();
      }
    }
    this.createValidations();
    this.getVehicleBrands();
    this.getZeroKMRule();
    this.getStartDateConfigs();
    this.validateFilledStartOfValidity();
    await this.getOriginalQuotation();
  },
  async mounted() {
    this.$refs.newQuotationForm.validate();
  },
  components: {
    ModalSelectVehicleModel,
    'v-select': vSelect,
    Money,
    CarregamentosForm,
    ProductsList,
    FinancialSummary,
    Modal,
    ValidationObserver,
    ValidationProvider,
    flatPickr,
    ModalHistoricoMensageria,
    ModalProposalHistory,
    EndorsementRefundScenarioAlert,
    RefundCompensationSummary,
    ImpactedInstallmentsList,
    RefundPayoutForm,
  },
};
</script>
<style lang="scss">
.form-landing {
  font-family: 'Roboto';
  padding-top: 60px;
  min-height: 80vh;

  .coluna-switch {
    padding: 0px 5px;

    div {
      background-color: #eff7ff;
      padding: 10px;
      min-height: 60px;
      vertical-align: middle;

      .label-switch {
        font-size: 12px;
        color: #078fcf;
      }
    }
  }

  label,
  .vs-input--label {
    color: #078fcf !important;
    font-size: 1rem;
  }

  .vs-input--input,
  .vs__dropdown-toggle,
  .vs-con-input .vs-inputx {
    height: 52px;
    background: white;
    border-radius: 9px;
    border: 1px #eeeeee solid !important;
  }
}

.botaoContratarAgora {
  background-color: #158c12;
  border-radius: 1rem;
  font-size: 1rem;
  color: #ffffff;
  padding: 1rem 2rem 1rem 2rem;
  transition: background-color 0.3s;
  font-family: 'Product Sans', sans-serif;
  cursor: pointer;
  border: 0;
  text-align: center;

  img {
    float: right;
    margin-top: 5px;
  }
}

.checkBoxNomeSocial {
  align-self: center;
}
</style>
<style scoped>
.input-data {
  width: 300px !important;
  max-width: 100% !important;
}

body {
  background-color: white;
}
.con-slot-label {
  width: 100%;
  margin-left: 10px;
}

.semPadding {
  padding: 0em 0em 0em 0em !important;
}

.container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.my-custom-money {
  font-size: 1.5em;
  color: #555555;
}

.my-custom-money-danger {
  font-size: 1.5em;
  color: #ea5455;
}

.my-custom-input {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #b4b4b4;
  border-radius: 8px;
}

.my-custom-input-danger {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #ea5455;
  border-radius: 8px;
}

#meu-popup-personalizado.con-vs-popup .vs-popup {
  width: fit-content;
}
</style>
<style lang="scss" scoped>
.vs__search,
.vs__search:focus {
  padding: 0 6px !important;
}

.vehicle-alert {
  background-color: rgba(var(--vs-primary), 0.15);
}

.fixed-buttons {
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #ccc;
  padding: 10px;
  margin-left: -25px;
  background-color: #fff;
  z-index: 999;
}

.painel-no-border {
  box-shadow: none !important;
  padding-bottom: 70px;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 10px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.item-lista {
  border: 1px solid #ccc;
  padding: 15px;
}

.form-part-title {
  padding: 1em;
  background: #d8e2ff;

  span {
    color: #2b50bb;
    font-weight: 600;
  }
}

.input-data-ativacao {
  width: 100%;
}
</style>
<style lang="scss" scoped>
.title-item-veiculo {
  border-bottom: 1px solid #000;
}

.text-danger {
  font-size: 12px;
}

.no-padding-cols > .vs-col {
  padding: 0 !important;
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip {
  visibility: hidden;
  width: 200px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 4px;

  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;

  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-wrapper:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.loading-financial-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4rem;
}

.loading-financial-list-wrapper {
  width: 100%;
  max-width: 100rem;
}

.alert-link {
  text-decoration: underline;
}

@media (min-width: 768px) {
  .loading-financial-wrapper {
    flex-direction: row;
    justify-content: space-between;
  }
  .loading-financial-list-wrapper {
    width: 47%;
  }
}

.purple-gradient-btn {
  background: #000000 !important;
  background-image: linear-gradient(
    30deg,
    rgba(135, 81, 252, 1),
    rgba(135, 81, 252, 0.5)
  ) !important;
}
</style>
